// A mock for an agent-portal quote request from zip 33133
export default {
  status: 'SUCCESS',
  data: {
    quoteKey: '3b5dc104-db03-4e5f-8f45-9c03d36d0296',
    agentInfo: {
      agentId: 'TEST_AGENT',
      agencyId: 'TEST',
      agentFirstName: 'TestQA',
      agentLastName: 'TestQA',
      agencyName: 'TestQA TestQA'
    },
    request: {
      location: {
        state: 'FL',
        zip: '33133'
      },
      members: [
        {
          dob: '04/11/1970',
          gender: 'M',
          role: 'PRIMARY'
        }
      ],
      coverage: {
        startDate: '11/28/2023'
      },
      products: [4, 5, 11, 17, 18, 16, 14, 6, 13, 15],
      plans: [],
      agentId: 'TEST_AGENT',
      audit: false
    },
    plans: {
      '10': {
        planId: 10,
        productId: 4,
        brochureId: 1,
        carrierId: 1,
        jsonId: 1,
        planName: 'Brilliant Dental™ Essential',
        authorizeName: 'renaissance',
        addOnPlanIds: [14],
        durations: [
          {
            policyDuration: 30,
            extendedDurationsAvailable: [],
            durationId: null,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2147483647,
            prepaid: null,
            monthly: {
              baseRate: 33.95,
              premium: 36.95,
              initialPayment: 36.95,
              taxes: [],
              fees: [
                {
                  name: 'subscription',
                  description: 'subscription',
                  value: 2
                },
                {
                  name: 'communicatingForAmerica',
                  description: 'communicatingForAmerica',
                  value: 1
                }
              ],
              coverageDuration: 0
            },
            members: []
          }
        ],
        coreBenefits: {
          majorServices: '10% | 20% | 30%',
          preventiveDiagnostic: '100%',
          deductible: '$50/$150',
          basicServices: '40% | 60% | 80%'
        },
        legacyId: '',
        oldPlanId: null
      },
      '11': {
        planId: 11,
        productId: 4,
        brochureId: 1,
        carrierId: 1,
        jsonId: 2,
        planName: 'Brilliant Dental™ Maximum',
        authorizeName: 'renaissance',
        addOnPlanIds: [14],
        durations: [
          {
            policyDuration: 30,
            extendedDurationsAvailable: [],
            durationId: null,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2147483647,
            prepaid: null,
            monthly: {
              baseRate: 61.29,
              premium: 64.29,
              initialPayment: 64.29,
              taxes: [],
              fees: [
                {
                  name: 'subscription',
                  description: 'subscription',
                  value: 2
                },
                {
                  name: 'communicatingForAmerica',
                  description: 'communicatingForAmerica',
                  value: 1
                }
              ],
              coverageDuration: 0
            },
            members: []
          }
        ],
        coreBenefits: {
          majorServices: '20% | 35% | 50%',
          deductible: '$50/$150',
          preventiveDiagnostic: '100%',
          basicServices: '60% | 70% | 80%'
        },
        legacyId: '',
        oldPlanId: null
      },
      '14': {
        planId: 14,
        productId: 5,
        brochureId: null,
        carrierId: 1,
        jsonId: 4,
        planName: 'Vision',
        authorizeName: 'renaissance',
        addOnPlanIds: [],
        durations: [
          {
            policyDuration: 30,
            extendedDurationsAvailable: [],
            durationId: null,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2147483647,
            prepaid: null,
            monthly: {
              baseRate: 7.96,
              premium: 8.71,
              initialPayment: 8.71,
              taxes: [],
              fees: [
                {
                  name: 'subscription',
                  description: 'subscription',
                  value: 0.75
                }
              ],
              coverageDuration: 0
            },
            members: []
          }
        ],
        coreBenefits: {},
        legacyId: '',
        oldPlanId: null
      },
      '214': {
        planId: 214,
        productId: 11,
        brochureId: 2,
        carrierId: 3,
        jsonId: 5,
        planName: 'Pivot Health Quantum PPO Copay Plan 100%',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 2381.17,
              premium: 2500.87,
              initialPayment: 2520.82,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 416.81,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 529.11,
              premium: 549.06,
              initialPayment: 569.01,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 529.11,
                dailyPremium: 13.23,
                prepaidPremium: 2381.17
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 710.41,
              premium: 730.36,
              initialPayment: 750.31,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 710.41,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 571.59,
              premium: 591.54,
              initialPayment: 611.49,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 571.59,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 776.14,
              premium: 796.09,
              initialPayment: 816.04,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 776.14,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 820.19,
              premium: 840.14,
              initialPayment: 860.09,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 820.19,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          negotiatedDiscount: '1',
          officeVisitCopaySpecialist: '60',
          officeVisitCopayGeneralPractitioner: '30',
          networkProvider: 'cigna',
          network: 'PPO',
          networkProviderLogo: 'cigna-logo',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayFrequencyLimitation: '3',
          outOfPocketMax: '10000',
          emergencyRoomCopay: '250',
          quantumType: 'copay',
          deductible: '10000',
          officeVisitCopay: '$30/$60/$60',
          officeVisitCopayDescription:
            '$30 General Practitioner / $60 Specialist and Urgent Care Facility',
          inpatientCopay: '0',
          rxSchedule: '04',
          lifetimeMax: '1000000',
          outpatientFacilityCopay: '0',
          coinsurance: '100',
          deductibleFamily: '20000',
          userCoinsurance: '0',
          rxScheduleDescription:
            '$10/$30/$75 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'CLIC-STM-QUA-10000-1000000-0',
        oldPlanId: null
      },
      '215': {
        planId: 215,
        productId: 11,
        brochureId: 2,
        carrierId: 3,
        jsonId: 6,
        planName: 'Pivot Health Quantum PPO HD Plan 100%',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1849.8,
              premium: 1969.5,
              initialPayment: 1989.45,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 328.25,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 411.07,
              premium: 431.02,
              initialPayment: 450.97,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 411.07,
                dailyPremium: 10.28,
                prepaidPremium: 1849.8
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 551.05,
              premium: 571,
              initialPayment: 590.95,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 551.05,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 443.86,
              premium: 463.81,
              initialPayment: 483.76,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 443.86,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 601.8,
              premium: 621.75,
              initialPayment: 641.7,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 601.8,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 635.82,
              premium: 655.77,
              initialPayment: 675.72,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 635.82,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          lifetimeMax: '1000000',
          inpatientCopay: '500',
          deductible: '10000',
          userCoinsurance: '0',
          rxSchedule: '01',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          deductibleFamily: '30000',
          coinsurance: '100',
          outpatientFacilityCopay: '0',
          quantumType: 'hd',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          negotiatedDiscount: '1',
          officeVisitCopaySpecialist: '60',
          officeVisitCopayGeneralPractitioner: '30',
          networkProvider: 'cigna',
          network: 'PPO',
          networkProviderLogo: 'cigna-logo',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayFrequencyLimitation: '3',
          outOfPocketMax: '10000',
          emergencyRoomCopay: '250',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-QUA-10000-1000000-0-HD',
        oldPlanId: null
      },
      '216': {
        planId: 216,
        productId: 11,
        brochureId: 2,
        carrierId: 3,
        jsonId: 7,
        planName: 'Pivot Health Quantum PPO Copay Plan 80%',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 3166.32,
              premium: 3286.02,
              initialPayment: 3305.97,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 547.67,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 703.59,
              premium: 723.54,
              initialPayment: 743.49,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 703.59,
                dailyPremium: 17.59,
                prepaidPremium: 3166.32
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 948.96,
              premium: 968.91,
              initialPayment: 988.86,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 948.96,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 761.08,
              premium: 781.03,
              initialPayment: 800.98,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 761.08,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 1037.93,
              premium: 1057.88,
              initialPayment: 1077.83,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 1037.93,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 1097.55,
              premium: 1117.5,
              initialPayment: 1137.45,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 1097.55,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          negotiatedDiscount: '1',
          officeVisitCopaySpecialist: '60',
          officeVisitCopayGeneralPractitioner: '30',
          networkProvider: 'cigna',
          network: 'PPO',
          networkProviderLogo: 'cigna-logo',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayFrequencyLimitation: '3',
          outOfPocketMax: '10000',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          officeVisitCopayDescription:
            '$30 General Practitioner / $60 Specialist and Urgent Care Facility',
          inpatientCopay: '0',
          rxSchedule: '04',
          officeVisitCopay: '$30/$60/$60',
          userCoinsurance: '20',
          deductible: '2500',
          lifetimeMax: '500000',
          quantumType: 'copay',
          coinsurance: '80',
          deductibleFamily: '5000',
          rxScheduleDescription:
            '$10/$30/$75 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'CLIC-STM-QUA-2500-500000',
        oldPlanId: null
      },
      '217': {
        planId: 217,
        productId: 11,
        brochureId: 2,
        carrierId: 3,
        jsonId: 7,
        planName: 'Pivot Health Quantum PPO Copay Plan 80%',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 2479.72,
              premium: 2599.42,
              initialPayment: 2619.37,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 433.24,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 551.01,
              premium: 570.96,
              initialPayment: 590.91,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 551.01,
                dailyPremium: 13.78,
                prepaidPremium: 2479.72
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 741.95,
              premium: 761.9,
              initialPayment: 781.85,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 741.95,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 595.74,
              premium: 615.69,
              initialPayment: 635.64,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 595.74,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 811.17,
              premium: 831.12,
              initialPayment: 851.07,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 811.17,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 857.57,
              premium: 877.52,
              initialPayment: 897.47,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 857.57,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          negotiatedDiscount: '1',
          officeVisitCopaySpecialist: '60',
          officeVisitCopayGeneralPractitioner: '30',
          networkProvider: 'cigna',
          network: 'PPO',
          networkProviderLogo: 'cigna-logo',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayFrequencyLimitation: '3',
          outOfPocketMax: '10000',
          emergencyRoomCopay: '250',
          lifetimeMax: '500000',
          deductible: '5000',
          officeVisitCopayDescription:
            '$30 General Practitioner / $60 Specialist and Urgent Care Facility',
          coinsurance: '80',
          quantumType: 'copay',
          deductibleFamily: '10000',
          rxSchedule: '04',
          officeVisitCopay: '$30/$60/$60',
          outpatientFacilityCopay: '0',
          inpatientCopay: '0',
          userCoinsurance: '20',
          rxScheduleDescription:
            '$10/$30/$75 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'CLIC-STM-QUA-5000-500000',
        oldPlanId: null
      },
      '218': {
        planId: 218,
        productId: 11,
        brochureId: 2,
        carrierId: 3,
        jsonId: 10,
        planName: 'Pivot Health Quantum PPO HD Plan 70%',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1863.47,
              premium: 1983.17,
              initialPayment: 2003.12,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 330.53,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 414.1,
              premium: 434.05,
              initialPayment: 454,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 414.1,
                dailyPremium: 10.35,
                prepaidPremium: 1863.47
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 557.12,
              premium: 577.07,
              initialPayment: 597.02,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 557.12,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 447.61,
              premium: 467.56,
              initialPayment: 487.51,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 447.61,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 608.98,
              premium: 628.93,
              initialPayment: 648.88,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 608.98,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 643.73,
              premium: 663.68,
              initialPayment: 683.63,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 643.73,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          negotiatedDiscount: '1',
          officeVisitCopaySpecialist: '60',
          officeVisitCopayGeneralPractitioner: '30',
          networkProvider: 'cigna',
          network: 'PPO',
          networkProviderLogo: 'cigna-logo',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayFrequencyLimitation: '3',
          outOfPocketMax: '10000',
          emergencyRoomCopay: '250',
          deductible: '5000',
          userCoinsurance: '30',
          inpatientCopay: '500',
          lifetimeMax: '500000',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          coinsurance: '70',
          outpatientFacilityCopay: '0',
          deductibleFamily: '15000',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          quantumType: 'hd',
          rxSchedule: '01',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-QUA-5000-500000-30-HD',
        oldPlanId: null
      },
      '243': {
        planId: 243,
        productId: 11,
        brochureId: 2,
        carrierId: 3,
        jsonId: 7,
        planName: 'Pivot Health Quantum PPO Copay Plan 80%',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 2587.73,
              premium: 2707.43,
              initialPayment: 2727.38,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 451.24,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 575.01,
              premium: 594.96,
              initialPayment: 614.91,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 575.01,
                dailyPremium: 14.38,
                prepaidPremium: 2587.73
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 774.35,
              premium: 794.3,
              initialPayment: 814.25,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 774.35,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 621.71,
              premium: 641.66,
              initialPayment: 661.61,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 621.71,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 846.62,
              premium: 866.57,
              initialPayment: 886.52,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 846.62,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 895.06,
              premium: 915.01,
              initialPayment: 934.96,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 895.06,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopay: '$30/$60/$60',
          coinsurance: '80',
          lifetimeMax: '1000000',
          officeVisitCopayDescription:
            '$30 General Practitioner / $60 Specialist and Urgent Care Facility',
          userCoinsurance: '20',
          deductibleFamily: '10000',
          outpatientFacilityCopay: 'none',
          rxSchedule: '04',
          inpatientCopay: 'none',
          quantumType: 'copay',
          deductible: '5000',
          negotiatedDiscount: '1',
          officeVisitCopaySpecialist: '60',
          officeVisitCopayGeneralPractitioner: '30',
          networkProvider: 'cigna',
          network: 'PPO',
          networkProviderLogo: 'cigna-logo',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayFrequencyLimitation: '3',
          outOfPocketMax: '10000',
          emergencyRoomCopay: '250',
          rxScheduleDescription:
            '$10/$30/$75 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'CLIC-STM-QUA-5000-1000000',
        oldPlanId: null
      },
      '244': {
        planId: 244,
        productId: 11,
        brochureId: 2,
        carrierId: 3,
        jsonId: 10,
        planName: 'Pivot Health Quantum PPO HD Plan 70%',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1960.25,
              premium: 2079.95,
              initialPayment: 2099.9,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 346.66,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 435.61,
              premium: 455.56,
              initialPayment: 475.51,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 435.61,
                dailyPremium: 10.89,
                prepaidPremium: 1960.25
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 586.16,
              premium: 606.11,
              initialPayment: 626.06,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 586.16,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 470.88,
              premium: 490.83,
              initialPayment: 510.78,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 470.88,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 640.74,
              premium: 660.69,
              initialPayment: 680.64,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 640.74,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 677.32,
              premium: 697.27,
              initialPayment: 717.22,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 677.32,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          deductibleFamily: '15000',
          rxSchedule: '01',
          inpatientCopay: '500',
          lifetimeMax: '1000000',
          userCoinsurance: '30',
          outpatientFacilityCopay: '0',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          deductible: '5000',
          quantumType: 'hd',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          coinsurance: '70',
          negotiatedDiscount: '1',
          officeVisitCopaySpecialist: '60',
          officeVisitCopayGeneralPractitioner: '30',
          networkProvider: 'cigna',
          network: 'PPO',
          networkProviderLogo: 'cigna-logo',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayFrequencyLimitation: '3',
          outOfPocketMax: '10000',
          emergencyRoomCopay: '250',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-QUA-5000-1000000-30-HD',
        oldPlanId: null
      },
      '245': {
        planId: 245,
        productId: 11,
        brochureId: 2,
        carrierId: 3,
        jsonId: 6,
        planName: 'Pivot Health Quantum PPO HD Plan 100%',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1759.81,
              premium: 1879.51,
              initialPayment: 1899.46,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 313.25,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 391.07,
              premium: 411.02,
              initialPayment: 430.97,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 391.07,
                dailyPremium: 9.78,
                prepaidPremium: 1759.81
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 524.05,
              premium: 544,
              initialPayment: 563.95,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 524.05,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 422.22,
              premium: 442.17,
              initialPayment: 462.12,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 422.22,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 572.27,
              premium: 592.22,
              initialPayment: 612.17,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 572.27,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 604.58,
              premium: 624.53,
              initialPayment: 644.48,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 604.58,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          negotiatedDiscount: '1',
          officeVisitCopaySpecialist: '60',
          officeVisitCopayGeneralPractitioner: '30',
          networkProvider: 'cigna',
          network: 'PPO',
          networkProviderLogo: 'cigna-logo',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayFrequencyLimitation: '3',
          outOfPocketMax: '10000',
          emergencyRoomCopay: '250',
          deductible: '10000',
          outpatientFacilityCopay: '0',
          quantumType: 'hd',
          rxSchedule: '01',
          inpatientCopay: '500',
          coinsurance: '100',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          deductibleFamily: '30000',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          lifetimeMax: '500000',
          userCoinsurance: '0',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-QUA-10000-500000-0-HD',
        oldPlanId: null
      },
      '246': {
        planId: 246,
        productId: 11,
        brochureId: 2,
        carrierId: 3,
        jsonId: 5,
        planName: 'Pivot Health Quantum PPO Copay Plan 100%',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 2284.75,
              premium: 2404.45,
              initialPayment: 2424.4,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 400.74,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 507.68,
              premium: 527.63,
              initialPayment: 547.58,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 507.68,
                dailyPremium: 12.69,
                prepaidPremium: 2284.75
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 681.48,
              premium: 701.43,
              initialPayment: 721.38,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 681.48,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 548.4,
              premium: 568.35,
              initialPayment: 588.3,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 548.4,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 744.5,
              premium: 764.45,
              initialPayment: 784.4,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 744.5,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 786.73,
              premium: 806.68,
              initialPayment: 826.63,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 786.73,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          negotiatedDiscount: '1',
          officeVisitCopaySpecialist: '60',
          officeVisitCopayGeneralPractitioner: '30',
          networkProvider: 'cigna',
          network: 'PPO',
          networkProviderLogo: 'cigna-logo',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayFrequencyLimitation: '3',
          outOfPocketMax: '10000',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: 'none',
          quantumType: 'copay',
          officeVisitCopay: '$30/$60/$60',
          deductible: '10000',
          inpatientCopay: 'none',
          rxSchedule: '04',
          deductibleFamily: '20000',
          lifetimeMax: '500000',
          officeVisitCopayDescription:
            '$30 General Practitioner / $60 Specialist and Urgent Care Facility',
          coinsurance: '100',
          userCoinsurance: '0',
          rxScheduleDescription:
            '$10/$30/$75 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'CLIC-STM-QUA-10000-500000-0',
        oldPlanId: null
      },
      '247': {
        planId: 247,
        productId: 11,
        brochureId: 2,
        carrierId: 3,
        jsonId: 7,
        planName: 'Pivot Health Quantum PPO Copay Plan 80%',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 3311.17,
              premium: 3430.87,
              initialPayment: 3450.82,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 571.81,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 735.78,
              premium: 755.73,
              initialPayment: 775.68,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 735.78,
                dailyPremium: 18.4,
                prepaidPremium: 3311.17
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 992.42,
              premium: 1012.37,
              initialPayment: 1032.32,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 992.42,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 795.9,
              premium: 815.85,
              initialPayment: 835.8,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 795.9,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 1085.47,
              premium: 1105.42,
              initialPayment: 1125.37,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 1085.47,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 1147.83,
              premium: 1167.78,
              initialPayment: 1187.73,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 1147.83,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          negotiatedDiscount: '1',
          officeVisitCopaySpecialist: '60',
          officeVisitCopayGeneralPractitioner: '30',
          networkProvider: 'cigna',
          network: 'PPO',
          networkProviderLogo: 'cigna-logo',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayFrequencyLimitation: '3',
          outOfPocketMax: '10000',
          emergencyRoomCopay: '250',
          coinsurance: '80',
          outpatientFacilityCopay: 'none',
          quantumType: 'copay',
          officeVisitCopay: '$30/$60/$60',
          deductibleFamily: '5000',
          deductible: '2500',
          rxSchedule: '04',
          userCoinsurance: '20',
          officeVisitCopayDescription:
            '$30 General Practitioner / $60 Specialist and Urgent Care Facility',
          lifetimeMax: '1000000',
          inpatientCopay: 'none',
          rxScheduleDescription:
            '$10/$30/$75 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'CLIC-STM-QUA-2500-1000000',
        oldPlanId: null
      },
      '293': {
        planId: 293,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 9,
        planName: 'Pivot Health Epic PPO',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 2513.1,
              premium: 2632.8,
              initialPayment: 2652.75,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 438.8,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 558.47,
              premium: 578.42,
              initialPayment: 598.37,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 558.47,
                dailyPremium: 13.96,
                prepaidPremium: 2513.1
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 753.94,
              premium: 773.89,
              initialPayment: 793.84,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 753.94,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 625.49,
              premium: 645.44,
              initialPayment: 665.39,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 625.49,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 799.17,
              premium: 819.12,
              initialPayment: 839.07,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 799.17,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          deductibleFamily: '10000',
          outOfPocketMax: '5000',
          outNetworkLifetimeMax: '375000',
          outNetworkDeductible: '6600',
          lifetimeMax: '500000',
          deductible: '5000',
          outNetworkFamilyDeductible: '13200',
          rxSchedule: '01',
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          planType: 'Epic High Deductible PPO',
          network: 'PPO',
          networkProvider: 'cigna',
          coinsurance: '100',
          userCoinsurance: '0',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'NRIC-EPIC-PPO-5000-500000',
        oldPlanId: null
      },
      '294': {
        planId: 294,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 9,
        planName: 'Pivot Health Epic PPO',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 2081.6,
              premium: 2201.3,
              initialPayment: 2221.25,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 366.88,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 462.58,
              premium: 482.53,
              initialPayment: 502.48,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 462.58,
                dailyPremium: 11.56,
                prepaidPremium: 2081.6
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 624.49,
              premium: 644.44,
              initialPayment: 664.39,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 624.49,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 518.09,
              premium: 538.04,
              initialPayment: 557.99,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 518.09,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 661.96,
              premium: 681.91,
              initialPayment: 701.86,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 661.96,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          planType: 'Epic High Deductible PPO',
          network: 'PPO',
          networkProvider: 'cigna',
          coinsurance: '100',
          userCoinsurance: '0',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          outNetworkLifetimeMax: '375000',
          rxSchedule: '01',
          outNetworkFamilyDeductible: '21200',
          deductible: '8000',
          deductibleFamily: '16000',
          outOfPocketMax: '8000',
          lifetimeMax: '500000',
          outNetworkDeductible: '10600',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'NRIC-EPIC-PPO-8000-500000',
        oldPlanId: null
      },
      '295': {
        planId: 295,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 9,
        planName: 'Pivot Health Epic PPO',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 2010.48,
              premium: 2130.18,
              initialPayment: 2150.13,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 355.03,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 446.78,
              premium: 466.73,
              initialPayment: 486.68,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 446.78,
                dailyPremium: 11.17,
                prepaidPremium: 2010.48
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 603.15,
              premium: 623.1,
              initialPayment: 643.05,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 603.15,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 500.39,
              premium: 520.34,
              initialPayment: 540.29,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 500.39,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 639.34,
              premium: 659.29,
              initialPayment: 679.24,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 639.34,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          planType: 'Epic High Deductible PPO',
          network: 'PPO',
          networkProvider: 'cigna',
          coinsurance: '100',
          userCoinsurance: '0',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          lifetimeMax: '500000',
          rxSchedule: '01',
          outOfPocketMax: '10000',
          deductibleFamily: '20000',
          outNetworkLifetimeMax: '375000',
          deductible: '10000',
          outNetworkDeductible: '13300',
          outNetworkFamilyDeductible: '26600',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'NRIC-EPIC-PPO-10000-500000',
        oldPlanId: null
      },
      '296': {
        planId: 296,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 9,
        planName: 'Pivot Health Epic PPO',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 2645.37,
              premium: 2765.07,
              initialPayment: 2785.02,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 460.84,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 587.86,
              premium: 607.81,
              initialPayment: 627.76,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 587.86,
                dailyPremium: 14.7,
                prepaidPremium: 2645.37
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 793.62,
              premium: 813.57,
              initialPayment: 833.52,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 793.62,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 658.41,
              premium: 678.36,
              initialPayment: 698.31,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 658.41,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 841.23,
              premium: 861.18,
              initialPayment: 881.13,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 841.23,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          planType: 'Epic High Deductible PPO',
          network: 'PPO',
          networkProvider: 'cigna',
          coinsurance: '100',
          userCoinsurance: '0',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          outNetworkLifetimeMax: '750000',
          rxSchedule: '01',
          deductibleFamily: '10000',
          outOfPocketMax: '5000',
          deductible: '5000',
          outNetworkDeductible: '6600',
          outNetworkFamilyDeductible: '13200',
          lifetimeMax: '1000000',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'NRIC-EPIC-PPO-5000-1000000',
        oldPlanId: null
      },
      '297': {
        planId: 297,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 9,
        planName: 'Pivot Health Epic PPO',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 2191.16,
              premium: 2310.86,
              initialPayment: 2330.81,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 385.14,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 486.93,
              premium: 506.88,
              initialPayment: 526.83,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 486.93,
                dailyPremium: 12.17,
                prepaidPremium: 2191.16
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 657.35,
              premium: 677.3,
              initialPayment: 697.25,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 657.35,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 545.36,
              premium: 565.31,
              initialPayment: 585.26,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 545.36,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 696.8,
              premium: 716.75,
              initialPayment: 736.7,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 696.8,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          planType: 'Epic High Deductible PPO',
          network: 'PPO',
          networkProvider: 'cigna',
          coinsurance: '100',
          userCoinsurance: '0',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          deductibleFamily: '16000',
          deductible: '8000',
          outOfPocketMax: '8000',
          outNetworkDeductible: '10600',
          lifetimeMax: '1000000',
          rxSchedule: '01',
          outNetworkLifetimeMax: '750000',
          outNetworkFamilyDeductible: '21200',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'NRIC-EPIC-PPO-8000-1000000',
        oldPlanId: null
      },
      '298': {
        planId: 298,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 9,
        planName: 'Pivot Health Epic PPO',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 2116.29,
              premium: 2235.99,
              initialPayment: 2255.94,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 372.66,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 470.29,
              premium: 490.24,
              initialPayment: 510.19,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 470.29,
                dailyPremium: 11.76,
                prepaidPremium: 2116.29
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 634.89,
              premium: 654.84,
              initialPayment: 674.79,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 634.89,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 526.73,
              premium: 546.68,
              initialPayment: 566.63,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 526.73,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 672.99,
              premium: 692.94,
              initialPayment: 712.89,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 672.99,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          planType: 'Epic High Deductible PPO',
          network: 'PPO',
          networkProvider: 'cigna',
          coinsurance: '100',
          userCoinsurance: '0',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          outOfPocketMax: '10000',
          outNetworkFamilyDeductible: '26600',
          lifetimeMax: '1000000',
          outNetworkLifetimeMax: '750000',
          deductible: '10000',
          rxSchedule: '01',
          outNetworkDeductible: '13300',
          deductibleFamily: '20000',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'NRIC-EPIC-PPO-10000-1000000',
        oldPlanId: null
      },
      '299': {
        planId: 299,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 11,
        planName: 'Pivot Health Epic PPO',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 2714.42,
              premium: 2834.12,
              initialPayment: 2854.07,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 472.35,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 603.21,
              premium: 623.16,
              initialPayment: 643.11,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 603.21,
                dailyPremium: 15.08,
                prepaidPremium: 2714.42
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 814.33,
              premium: 834.28,
              initialPayment: 854.23,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 814.33,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 675.59,
              premium: 695.54,
              initialPayment: 715.49,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 675.59,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 863.19,
              premium: 883.14,
              initialPayment: 903.09,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 863.19,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          planType: 'Epic High Deductible PPO',
          network: 'PPO',
          networkProvider: 'cigna',
          coinsurance: '100',
          userCoinsurance: '0',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          outNetworkDeductible: '6600',
          outNetworkFamilyDeductible: '13200',
          lifetimeMax: '500000',
          rxSchedule: '04',
          outNetworkLifetimeMax: '375000',
          deductible: '5000',
          outOfPocketMax: '5000',
          deductibleFamily: '10000',
          rxScheduleDescription:
            '$5/$35/$70 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'NRIC-EPIC-PPO-RX-5000-500000',
        oldPlanId: null
      },
      '300': {
        planId: 300,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 11,
        planName: 'Pivot Health Epic PPO',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 2282.93,
              premium: 2402.63,
              initialPayment: 2422.58,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 400.44,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 507.32,
              premium: 527.27,
              initialPayment: 547.22,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 507.32,
                dailyPremium: 12.68,
                prepaidPremium: 2282.93
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 684.88,
              premium: 704.83,
              initialPayment: 724.78,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 684.88,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 568.2,
              premium: 588.15,
              initialPayment: 608.1,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 568.2,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 725.98,
              premium: 745.93,
              initialPayment: 765.88,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 725.98,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          planType: 'Epic High Deductible PPO',
          network: 'PPO',
          networkProvider: 'cigna',
          coinsurance: '100',
          userCoinsurance: '0',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          outOfPocketMax: '8000',
          outNetworkDeductible: '10600',
          outNetworkLifetimeMax: '375000',
          deductible: '8000',
          outNetworkFamilyDeductible: '21200',
          rxSchedule: '04',
          lifetimeMax: '500000',
          deductibleFamily: '16000',
          rxScheduleDescription:
            '$5/$35/$70 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'NRIC-EPIC-PPO-RX-8000-500000',
        oldPlanId: null
      },
      '301': {
        planId: 301,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 11,
        planName: 'Pivot Health Epic PPO',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 2211.8,
              premium: 2331.5,
              initialPayment: 2351.45,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 388.58,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 491.52,
              premium: 511.47,
              initialPayment: 531.42,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 491.52,
                dailyPremium: 12.29,
                prepaidPremium: 2211.8
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 663.55,
              premium: 683.5,
              initialPayment: 703.45,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 663.55,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 550.5,
              premium: 570.45,
              initialPayment: 590.4,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 550.5,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 703.36,
              premium: 723.31,
              initialPayment: 743.26,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 703.36,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          planType: 'Epic High Deductible PPO',
          network: 'PPO',
          networkProvider: 'cigna',
          coinsurance: '100',
          userCoinsurance: '0',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          rxSchedule: '04',
          lifetimeMax: '500000',
          deductible: '10000',
          outNetworkDeductible: '13300',
          outOfPocketMax: '10000',
          outNetworkLifetimeMax: '375000',
          outNetworkFamilyDeductible: '26600',
          deductibleFamily: '20000',
          rxScheduleDescription:
            '$5/$35/$70 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'NRIC-EPIC-PPO-RX-10000-500000',
        oldPlanId: null
      },
      '302': {
        planId: 302,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 11,
        planName: 'Pivot Health Epic PPO',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 2846.69,
              premium: 2966.39,
              initialPayment: 2986.34,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 494.4,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 632.6,
              premium: 652.55,
              initialPayment: 672.5,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 632.6,
                dailyPremium: 15.81,
                prepaidPremium: 2846.69
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 854.01,
              premium: 873.96,
              initialPayment: 893.91,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 854.01,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 708.51,
              premium: 728.46,
              initialPayment: 748.41,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 708.51,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 905.25,
              premium: 925.2,
              initialPayment: 945.15,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 905.25,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          planType: 'Epic High Deductible PPO',
          network: 'PPO',
          networkProvider: 'cigna',
          coinsurance: '100',
          userCoinsurance: '0',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          outNetworkDeductible: '6600',
          deductible: '5000',
          rxSchedule: '04',
          outNetworkLifetimeMax: '750000',
          outNetworkFamilyDeductible: '13200',
          lifetimeMax: '1000000',
          outOfPocketMax: '5000',
          deductibleFamily: '10000',
          rxScheduleDescription:
            '$5/$35/$70 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'NRIC-EPIC-PPO-RX-5000-1000000',
        oldPlanId: null
      },
      '303': {
        planId: 303,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 11,
        planName: 'Pivot Health Epic PPO',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 2392.48,
              premium: 2512.18,
              initialPayment: 2532.13,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 418.7,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 531.67,
              premium: 551.62,
              initialPayment: 571.57,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 531.67,
                dailyPremium: 13.29,
                prepaidPremium: 2392.48
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 717.75,
              premium: 737.7,
              initialPayment: 757.65,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 717.75,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 595.47,
              premium: 615.42,
              initialPayment: 635.37,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 595.47,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 760.82,
              premium: 780.77,
              initialPayment: 800.72,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 760.82,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          planType: 'Epic High Deductible PPO',
          network: 'PPO',
          networkProvider: 'cigna',
          coinsurance: '100',
          userCoinsurance: '0',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          outNetworkDeductible: '10600',
          outNetworkFamilyDeductible: '21200',
          rxSchedule: '04',
          deductible: '8000',
          lifetimeMax: '1000000',
          deductibleFamily: '16000',
          outOfPocketMax: '8000',
          outNetworkLifetimeMax: '750000',
          rxScheduleDescription:
            '$5/$35/$70 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'NRIC-EPIC-PPO-RX-8000-1000000',
        oldPlanId: null
      },
      '304': {
        planId: 304,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 11,
        planName: 'Pivot Health Epic PPO',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 2317.62,
              premium: 2437.32,
              initialPayment: 2457.27,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 406.22,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 515.03,
              premium: 534.98,
              initialPayment: 554.93,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 515.03,
                dailyPremium: 12.88,
                prepaidPremium: 2317.62
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 695.29,
              premium: 715.24,
              initialPayment: 735.19,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 695.29,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 576.83,
              premium: 596.78,
              initialPayment: 616.73,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 576.83,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 737.01,
              premium: 756.96,
              initialPayment: 776.91,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 737.01,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          planType: 'Epic High Deductible PPO',
          network: 'PPO',
          networkProvider: 'cigna',
          coinsurance: '100',
          userCoinsurance: '0',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          outNetworkLifetimeMax: '750000',
          deductibleFamily: '20000',
          deductible: '10000',
          rxSchedule: '04',
          outNetworkFamilyDeductible: '26600',
          outOfPocketMax: '10000',
          outNetworkDeductible: '13300',
          lifetimeMax: '1000000',
          rxScheduleDescription:
            '$5/$35/$70 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'NRIC-EPIC-PPO-RX-10000-1000000',
        oldPlanId: null
      },
      '305': {
        planId: 305,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 12,
        planName: 'Pivot Health Epic Base',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1475.38,
              premium: 1595.08,
              initialPayment: 1615.03,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 265.85,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 327.87,
              premium: 347.82,
              initialPayment: 367.77,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 327.87,
                dailyPremium: 8.2,
                prepaidPremium: 1475.38
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 442.62,
              premium: 462.57,
              initialPayment: 482.52,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 442.62,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 367.21,
              premium: 387.16,
              initialPayment: 407.11,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 367.21,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 469.18,
              premium: 489.13,
              initialPayment: 509.08,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 469.18,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          outOfPocketMax: '5000',
          rxSchedule: '01',
          deductible: '5000',
          deductibleFamily: '10000',
          lifetimeMax: '500000',
          planType: 'Epic High Deductible RBP',
          networkProvider: 'any-provider',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          coinsurance: '100',
          userCoinsurance: '0',
          network: 'Non-PPO',
          patientAdvocacyServices: 'true',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'NRIC-EPIC-BAS-5000-500000',
        oldPlanId: null
      },
      '306': {
        planId: 306,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 12,
        planName: 'Pivot Health Epic Base',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1180.31,
              premium: 1300.01,
              initialPayment: 1319.96,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 216.67,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 262.29,
              premium: 282.24,
              initialPayment: 302.19,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 262.29,
                dailyPremium: 6.56,
                prepaidPremium: 1180.31
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 354.1,
              premium: 374.05,
              initialPayment: 394,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 354.1,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 293.77,
              premium: 313.72,
              initialPayment: 333.67,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 293.77,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 375.34,
              premium: 395.29,
              initialPayment: 415.24,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 375.34,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          deductible: '10000',
          deductibleFamily: '20000',
          outOfPocketMax: '10000',
          rxSchedule: '01',
          lifetimeMax: '500000',
          planType: 'Epic High Deductible RBP',
          networkProvider: 'any-provider',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          coinsurance: '100',
          userCoinsurance: '0',
          network: 'Non-PPO',
          patientAdvocacyServices: 'true',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'NRIC-EPIC-BAS-10000-500000',
        oldPlanId: null
      },
      '307': {
        planId: 307,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 12,
        planName: 'Pivot Health Epic Base',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 952.04,
              premium: 1071.74,
              initialPayment: 1091.69,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 178.62,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 211.57,
              premium: 231.52,
              initialPayment: 251.47,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 211.57,
                dailyPremium: 5.29,
                prepaidPremium: 952.04
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 285.61,
              premium: 305.56,
              initialPayment: 325.51,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 285.61,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 236.95,
              premium: 256.9,
              initialPayment: 276.85,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 236.95,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 302.75,
              premium: 322.7,
              initialPayment: 342.65,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 302.75,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          rxSchedule: '01',
          lifetimeMax: '500000',
          outOfPocketMax: '15000',
          deductibleFamily: '30000',
          deductible: '15000',
          planType: 'Epic High Deductible RBP',
          networkProvider: 'any-provider',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          coinsurance: '100',
          userCoinsurance: '0',
          network: 'Non-PPO',
          patientAdvocacyServices: 'true',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'NRIC-EPIC-BAS-15000-500000',
        oldPlanId: null
      },
      '308': {
        planId: 308,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 12,
        planName: 'Pivot Health Epic Base',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 796.15,
              premium: 915.85,
              initialPayment: 935.8,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 152.64,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 176.92,
              premium: 196.87,
              initialPayment: 216.82,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 176.92,
                dailyPremium: 4.42,
                prepaidPremium: 796.15
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 238.85,
              premium: 258.8,
              initialPayment: 278.75,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 238.85,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 198.15,
              premium: 218.1,
              initialPayment: 238.05,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 198.15,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 253.18,
              premium: 273.13,
              initialPayment: 293.08,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 253.18,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          outOfPocketMax: '20000',
          deductibleFamily: '40000',
          deductible: '20000',
          lifetimeMax: '500000',
          rxSchedule: '01',
          planType: 'Epic High Deductible RBP',
          networkProvider: 'any-provider',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          coinsurance: '100',
          userCoinsurance: '0',
          network: 'Non-PPO',
          patientAdvocacyServices: 'true',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'NRIC-EPIC-BAS-20000-500000',
        oldPlanId: null
      },
      '309': {
        planId: 309,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 12,
        planName: 'Pivot Health Epic Base',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1553.04,
              premium: 1672.74,
              initialPayment: 1692.69,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 278.79,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 345.12,
              premium: 365.07,
              initialPayment: 385.02,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 345.12,
                dailyPremium: 8.63,
                prepaidPremium: 1553.04
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 465.91,
              premium: 485.86,
              initialPayment: 505.81,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 465.91,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 386.54,
              premium: 406.49,
              initialPayment: 426.44,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 386.54,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 493.87,
              premium: 513.82,
              initialPayment: 533.77,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 493.87,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          deductibleFamily: '10000',
          outOfPocketMax: '5000',
          deductible: '5000',
          rxSchedule: '01',
          lifetimeMax: '1000000',
          planType: 'Epic High Deductible RBP',
          networkProvider: 'any-provider',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          coinsurance: '100',
          userCoinsurance: '0',
          network: 'Non-PPO',
          patientAdvocacyServices: 'true',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'NRIC-EPIC-BAS-5000-1000000',
        oldPlanId: null
      },
      '310': {
        planId: 310,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 12,
        planName: 'Pivot Health Epic Base',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1242.43,
              premium: 1362.13,
              initialPayment: 1382.08,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 227.02,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 276.1,
              premium: 296.05,
              initialPayment: 316,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 276.1,
                dailyPremium: 6.9,
                prepaidPremium: 1242.43
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 372.73,
              premium: 392.68,
              initialPayment: 412.63,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 372.73,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 309.23,
              premium: 329.18,
              initialPayment: 349.13,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 309.23,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 395.1,
              premium: 415.05,
              initialPayment: 435,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 395.1,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          rxSchedule: '01',
          deductible: '10000',
          lifetimeMax: '1000000',
          outOfPocketMax: '10000',
          deductibleFamily: '20000',
          planType: 'Epic High Deductible RBP',
          networkProvider: 'any-provider',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          coinsurance: '100',
          userCoinsurance: '0',
          network: 'Non-PPO',
          patientAdvocacyServices: 'true',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'NRIC-EPIC-BAS-10000-1000000',
        oldPlanId: null
      },
      '311': {
        planId: 311,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 12,
        planName: 'Pivot Health Epic Base',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1002.15,
              premium: 1121.85,
              initialPayment: 1141.8,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 186.98,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 222.7,
              premium: 242.65,
              initialPayment: 262.6,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 222.7,
                dailyPremium: 5.57,
                prepaidPremium: 1002.15
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 300.65,
              premium: 320.6,
              initialPayment: 340.55,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 300.65,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 249.43,
              premium: 269.38,
              initialPayment: 289.33,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 249.43,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 318.69,
              premium: 338.64,
              initialPayment: 358.59,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 318.69,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          deductible: '15000',
          lifetimeMax: '1000000',
          outOfPocketMax: '15000',
          deductibleFamily: '30000',
          rxSchedule: '01',
          planType: 'Epic High Deductible RBP',
          networkProvider: 'any-provider',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          coinsurance: '100',
          userCoinsurance: '0',
          network: 'Non-PPO',
          patientAdvocacyServices: 'true',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'NRIC-EPIC-BAS-15000-1000000',
        oldPlanId: null
      },
      '312': {
        planId: 312,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 12,
        planName: 'Pivot Health Epic Base',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 838.05,
              premium: 957.75,
              initialPayment: 977.7,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 159.62,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 186.24,
              premium: 206.19,
              initialPayment: 226.14,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 186.24,
                dailyPremium: 4.66,
                prepaidPremium: 838.05
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 251.42,
              premium: 271.37,
              initialPayment: 291.32,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 251.42,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 208.58,
              premium: 228.53,
              initialPayment: 248.48,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 208.58,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 266.5,
              premium: 286.45,
              initialPayment: 306.4,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 266.5,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          lifetimeMax: '1000000',
          deductibleFamily: '40000',
          outOfPocketMax: '20000',
          deductible: '20000',
          rxSchedule: '01',
          planType: 'Epic High Deductible RBP',
          networkProvider: 'any-provider',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          coinsurance: '100',
          userCoinsurance: '0',
          network: 'Non-PPO',
          patientAdvocacyServices: 'true',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'NRIC-EPIC-BAS-20000-1000000',
        oldPlanId: null
      },
      '313': {
        planId: 313,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 13,
        planName: 'Pivot Health Epic Base',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1676.71,
              premium: 1796.41,
              initialPayment: 1816.36,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 299.4,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 372.6,
              premium: 392.55,
              initialPayment: 412.5,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 372.6,
                dailyPremium: 9.32,
                prepaidPremium: 1676.71
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 503.02,
              premium: 522.97,
              initialPayment: 542.92,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 503.02,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 417.32,
              premium: 437.27,
              initialPayment: 457.22,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 417.32,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 533.2,
              premium: 553.15,
              initialPayment: 573.1,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 533.2,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          outOfPocketMax: '5000',
          lifetimeMax: '500000',
          rxSchedule: '04',
          deductibleFamily: '10000',
          deductible: '5000',
          planType: 'Epic High Deductible RBP',
          networkProvider: 'any-provider',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          coinsurance: '100',
          userCoinsurance: '0',
          network: 'Non-PPO',
          patientAdvocacyServices: 'true',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          rxScheduleDescription:
            '$5/$35/$70 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'NRIC-EPIC-BAS-RX-5000-500000',
        oldPlanId: null
      },
      '314': {
        planId: 314,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 13,
        planName: 'Pivot Health Epic Base',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1381.63,
              premium: 1501.33,
              initialPayment: 1521.28,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 250.22,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 307.03,
              premium: 326.98,
              initialPayment: 346.93,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 307.03,
                dailyPremium: 7.68,
                prepaidPremium: 1381.63
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 414.49,
              premium: 434.44,
              initialPayment: 454.39,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 414.49,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 343.87,
              premium: 363.82,
              initialPayment: 383.77,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 343.87,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 439.36,
              premium: 459.31,
              initialPayment: 479.26,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 439.36,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          planType: 'Epic High Deductible RBP',
          networkProvider: 'any-provider',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          coinsurance: '100',
          userCoinsurance: '0',
          network: 'Non-PPO',
          patientAdvocacyServices: 'true',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          lifetimeMax: '500000',
          rxSchedule: '04',
          deductible: '10000',
          outOfPocketMax: '10000',
          deductibleFamily: '20000',
          rxScheduleDescription:
            '$5/$35/$70 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'NRIC-EPIC-BAS-RX-10000-500000',
        oldPlanId: null
      },
      '315': {
        planId: 315,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 13,
        planName: 'Pivot Health Epic Base',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1153.36,
              premium: 1273.06,
              initialPayment: 1293.01,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 212.18,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 256.3,
              premium: 276.25,
              initialPayment: 296.2,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 256.3,
                dailyPremium: 6.41,
                prepaidPremium: 1153.36
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 346.01,
              premium: 365.96,
              initialPayment: 385.91,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 346.01,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 287.06,
              premium: 307.01,
              initialPayment: 326.96,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 287.06,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 366.77,
              premium: 386.72,
              initialPayment: 406.67,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 366.77,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          planType: 'Epic High Deductible RBP',
          networkProvider: 'any-provider',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          coinsurance: '100',
          userCoinsurance: '0',
          network: 'Non-PPO',
          patientAdvocacyServices: 'true',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          lifetimeMax: '500000',
          outOfPocketMax: '15000',
          deductible: '15000',
          deductibleFamily: '30000',
          rxSchedule: '04',
          rxScheduleDescription:
            '$5/$35/$70 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'NRIC-EPIC-BAS-RX-15000-500000',
        oldPlanId: null
      },
      '316': {
        planId: 316,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 13,
        planName: 'Pivot Health Epic Base',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 997.47,
              premium: 1117.17,
              initialPayment: 1137.12,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 186.2,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 221.66,
              premium: 241.61,
              initialPayment: 261.56,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 221.66,
                dailyPremium: 5.54,
                prepaidPremium: 997.47
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 299.24,
              premium: 319.19,
              initialPayment: 339.14,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 299.24,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 248.26,
              premium: 268.21,
              initialPayment: 288.16,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 248.26,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 317.2,
              premium: 337.15,
              initialPayment: 357.1,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 317.2,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          rxSchedule: '04',
          lifetimeMax: '500000',
          deductibleFamily: '40000',
          outOfPocketMax: '20000',
          deductible: '20000',
          planType: 'Epic High Deductible RBP',
          networkProvider: 'any-provider',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          coinsurance: '100',
          userCoinsurance: '0',
          network: 'Non-PPO',
          patientAdvocacyServices: 'true',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          rxScheduleDescription:
            '$5/$35/$70 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'NRIC-EPIC-BAS-RX-20000-500000',
        oldPlanId: null
      },
      '317': {
        planId: 317,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 13,
        planName: 'Pivot Health Epic Base',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1754.36,
              premium: 1874.06,
              initialPayment: 1894.01,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 312.34,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 389.86,
              premium: 409.81,
              initialPayment: 429.76,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 389.86,
                dailyPremium: 9.75,
                prepaidPremium: 1754.36
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 526.31,
              premium: 546.26,
              initialPayment: 566.21,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 526.31,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 436.64,
              premium: 456.59,
              initialPayment: 476.54,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 436.64,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 557.89,
              premium: 577.84,
              initialPayment: 597.79,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 557.89,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          planType: 'Epic High Deductible RBP',
          networkProvider: 'any-provider',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          coinsurance: '100',
          userCoinsurance: '0',
          network: 'Non-PPO',
          patientAdvocacyServices: 'true',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          lifetimeMax: '1000000',
          deductible: '5000',
          deductibleFamily: '10000',
          outOfPocketMax: '5000',
          rxSchedule: '04',
          rxScheduleDescription:
            '$5/$35/$70 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'NRIC-EPIC-BAS-RX-5000-1000000',
        oldPlanId: null
      },
      '318': {
        planId: 318,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 13,
        planName: 'Pivot Health Epic Base',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1443.75,
              premium: 1563.45,
              initialPayment: 1583.4,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 260.58,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 320.84,
              premium: 340.79,
              initialPayment: 360.74,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 320.84,
                dailyPremium: 8.02,
                prepaidPremium: 1443.75
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 433.13,
              premium: 453.08,
              initialPayment: 473.03,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 433.13,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 359.34,
              premium: 379.29,
              initialPayment: 399.24,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 359.34,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 459.12,
              premium: 479.07,
              initialPayment: 499.02,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 459.12,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          lifetimeMax: '1000000',
          deductibleFamily: '20000',
          rxSchedule: '04',
          outOfPocketMax: '10000',
          deductible: '10000',
          planType: 'Epic High Deductible RBP',
          networkProvider: 'any-provider',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          coinsurance: '100',
          userCoinsurance: '0',
          network: 'Non-PPO',
          patientAdvocacyServices: 'true',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          rxScheduleDescription:
            '$5/$35/$70 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'NRIC-EPIC-BAS-RX-10000-1000000',
        oldPlanId: null
      },
      '319': {
        planId: 319,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 13,
        planName: 'Pivot Health Epic Base',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1203.47,
              premium: 1323.17,
              initialPayment: 1343.12,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 220.53,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 267.44,
              premium: 287.39,
              initialPayment: 307.34,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 267.44,
                dailyPremium: 6.69,
                prepaidPremium: 1203.47
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 361.04,
              premium: 380.99,
              initialPayment: 400.94,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 361.04,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 299.53,
              premium: 319.48,
              initialPayment: 339.43,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 299.53,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 382.71,
              premium: 402.66,
              initialPayment: 422.61,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 382.71,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          planType: 'Epic High Deductible RBP',
          networkProvider: 'any-provider',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          coinsurance: '100',
          userCoinsurance: '0',
          network: 'Non-PPO',
          patientAdvocacyServices: 'true',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          deductible: '15000',
          deductibleFamily: '30000',
          rxSchedule: '04',
          outOfPocketMax: '15000',
          lifetimeMax: '1000000',
          rxScheduleDescription:
            '$5/$35/$70 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'NRIC-EPIC-BAS-RX-15000-1000000',
        oldPlanId: null
      },
      '320': {
        planId: 320,
        productId: 17,
        brochureId: 6,
        carrierId: 5,
        jsonId: 13,
        planName: 'Pivot Health Epic Base',
        authorizeName: 'nric',
        addOnPlanIds: [10, 11, 345, 325, 326],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1039.38,
              premium: 1159.08,
              initialPayment: 1179.03,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 193.18,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 230.97,
              premium: 250.92,
              initialPayment: 270.87,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 230.97,
                dailyPremium: 5.77,
                prepaidPremium: 1039.38
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 311.81,
              premium: 331.76,
              initialPayment: 351.71,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 311.81,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 258.69,
              premium: 278.64,
              initialPayment: 298.59,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 258.69,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 330.52,
              premium: 350.47,
              initialPayment: 370.42,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                monthlyPremium: 330.52,
                dailyPremium: 0,
                prepaidPremium: 0
              }
            ]
          }
        ],
        coreBenefits: {
          lifetimeMax: '1000000',
          deductible: '20000',
          rxSchedule: '04',
          outOfPocketMax: '20000',
          deductibleFamily: '40000',
          planType: 'Epic High Deductible RBP',
          networkProvider: 'any-provider',
          officeVisitCopay: 'Subject to deductible and coinsurance',
          coinsurance: '100',
          userCoinsurance: '0',
          network: 'Non-PPO',
          patientAdvocacyServices: 'true',
          officeVisitCopayDescription: 'Subject to deductible and coinsurance',
          emergencyRoomCopay:
            'After a copay of $250, Deductible and Coinsurance apply. Copay is waived if directly admitted into Inpatient.',
          SpecialistOfficeVisitCopay: 'Subject to deductible and coinsurance',
          rxScheduleDescription:
            '$5/$35/$70 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'NRIC-EPIC-BAS-RX-20000-1000000',
        oldPlanId: null
      },
      '325': {
        planId: 325,
        productId: 18,
        brochureId: 8,
        carrierId: 5,
        jsonId: 7,
        planName: 'EPIC Supplemental 5000',
        authorizeName: 'nric',
        addOnPlanIds: [],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 55.22,
              premium: 55.22,
              initialPayment: 55.22,
              taxes: [],
              fees: [],
              monthlyDiscountedRate: 9.2,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 12.27,
              premium: 12.27,
              initialPayment: 12.27,
              taxes: [],
              fees: [],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 12.27,
                dailyPremium: 0.31,
                prepaidPremium: 55.22
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 12.27,
              premium: 12.27,
              initialPayment: 12.27,
              taxes: [],
              fees: [],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 12.27,
                dailyPremium: 0.31,
                prepaidPremium: 111.67
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 12.27,
              premium: 12.27,
              initialPayment: 12.27,
              taxes: [],
              fees: [],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 12.27,
                dailyPremium: 0.31,
                prepaidPremium: 55.22
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 12.27,
              premium: 12.27,
              initialPayment: 12.27,
              taxes: [],
              fees: [],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 12.27,
                dailyPremium: 0.31,
                prepaidPremium: 111.67
              }
            ]
          }
        ],
        coreBenefits: {
          supplemental: '5000'
        },
        legacyId: 'SUP-5000',
        oldPlanId: null
      },
      '326': {
        planId: 326,
        productId: 18,
        brochureId: 8,
        carrierId: 5,
        jsonId: 7,
        planName: 'EPIC Supplemental 10000',
        authorizeName: 'nric',
        addOnPlanIds: [],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 93.87,
              premium: 93.87,
              initialPayment: 93.87,
              taxes: [],
              fees: [],
              monthlyDiscountedRate: 15.64,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 20.86,
              premium: 20.86,
              initialPayment: 20.86,
              taxes: [],
              fees: [],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 20.86,
                dailyPremium: 0.52,
                prepaidPremium: 93.87
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 20.86,
              premium: 20.86,
              initialPayment: 20.86,
              taxes: [],
              fees: [],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 20.86,
                dailyPremium: 0.52,
                prepaidPremium: 189.83
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 20.86,
              premium: 20.86,
              initialPayment: 20.86,
              taxes: [],
              fees: [],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 20.86,
                dailyPremium: 0.52,
                prepaidPremium: 93.87
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 20.86,
              premium: 20.86,
              initialPayment: 20.86,
              taxes: [],
              fees: [],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 20.86,
                dailyPremium: 0.52,
                prepaidPremium: 189.83
              }
            ]
          }
        ],
        coreBenefits: {
          supplemental: '10000'
        },
        legacyId: 'SUP-10000',
        oldPlanId: null
      },
      '345': {
        planId: 345,
        productId: 4,
        brochureId: 1,
        carrierId: 1,
        jsonId: 3,
        planName: 'Brilliant Dental™ Value',
        authorizeName: 'renaissance',
        addOnPlanIds: [14],
        durations: [
          {
            policyDuration: 30,
            extendedDurationsAvailable: [],
            durationId: null,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2147483647,
            prepaid: null,
            monthly: {
              baseRate: 28.1,
              premium: 31.1,
              initialPayment: 31.1,
              taxes: [],
              fees: [
                {
                  name: 'subscription',
                  description: 'subscription',
                  value: 2
                },
                {
                  name: 'communicatingForAmerica',
                  description: 'communicatingForAmerica',
                  value: 1
                }
              ],
              coverageDuration: 0
            },
            members: []
          }
        ],
        coreBenefits: {
          deductible: '$50/$150',
          preventiveDiagnostic: '100%',
          majorServices: '0%',
          basicServices: '80%'
        },
        legacyId: '',
        oldPlanId: null
      },
      '363': {
        planId: 363,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1792.23,
              premium: 1911.93,
              initialPayment: 1931.88,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 318.66,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 398.22,
              premium: 418.17,
              initialPayment: 438.12,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 398.22,
                dailyPremium: 9.96,
                prepaidPremium: 1792.23
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 537.6,
              premium: 557.55,
              initialPayment: 577.5,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 537.6,
                dailyPremium: 13.44,
                prepaidPremium: 4892.78
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 430.88,
              premium: 450.83,
              initialPayment: 470.78,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 430.88,
                dailyPremium: 10.77,
                prepaidPremium: 1939.19
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 588.14,
              premium: 608.09,
              initialPayment: 628.04,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 588.14,
                dailyPremium: 14.71,
                prepaidPremium: 5352.7
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 622.01,
              premium: 641.96,
              initialPayment: 661.91,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 622.01,
                dailyPremium: 15.55,
                prepaidPremium: 5660.94
              }
            ]
          }
        ],
        coreBenefits: {
          outOfPocketMax: '11000',
          deductible: '1000',
          coinsurance: '80',
          deductibleFamily: '3000',
          userCoinsurance: '20',
          lifetimeMax: '100000',
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-1000-11000-100000-20',
        oldPlanId: null
      },
      '364': {
        planId: 364,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 2090.93,
              premium: 2210.63,
              initialPayment: 2230.58,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 368.44,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 464.6,
              premium: 484.55,
              initialPayment: 504.5,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 464.6,
                dailyPremium: 11.62,
                prepaidPremium: 2090.93
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 627.2,
              premium: 647.15,
              initialPayment: 667.1,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 627.2,
                dailyPremium: 15.68,
                prepaidPremium: 5708.24
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 502.69,
              premium: 522.64,
              initialPayment: 542.59,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 502.69,
                dailyPremium: 12.57,
                prepaidPremium: 2262.39
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 686.16,
              premium: 706.11,
              initialPayment: 726.06,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 686.16,
                dailyPremium: 17.16,
                prepaidPremium: 6244.81
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 725.67,
              premium: 745.62,
              initialPayment: 765.57,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 725.67,
                dailyPremium: 18.14,
                prepaidPremium: 6604.43
              }
            ]
          }
        ],
        coreBenefits: {
          lifetimeMax: '250000',
          deductibleFamily: '3000',
          userCoinsurance: '20',
          coinsurance: '80',
          deductible: '1000',
          outOfPocketMax: '11000',
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-1000-11000-250000-20',
        oldPlanId: null
      },
      '365': {
        planId: 365,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 2364.74,
              premium: 2484.44,
              initialPayment: 2504.39,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 414.07,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 525.44,
              premium: 545.39,
              initialPayment: 565.34,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 525.44,
                dailyPremium: 13.14,
                prepaidPremium: 2364.74
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 709.34,
              premium: 729.29,
              initialPayment: 749.24,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 709.34,
                dailyPremium: 17.74,
                prepaidPremium: 6455.75
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 568.52,
              premium: 588.47,
              initialPayment: 608.42,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 568.52,
                dailyPremium: 14.21,
                prepaidPremium: 2558.65
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 776.02,
              premium: 795.97,
              initialPayment: 815.92,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 776.02,
                dailyPremium: 19.4,
                prepaidPremium: 7062.59
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 820.7,
              premium: 840.65,
              initialPayment: 860.6,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 820.7,
                dailyPremium: 20.52,
                prepaidPremium: 7469.3
              }
            ]
          }
        ],
        coreBenefits: {
          deductible: '1000',
          outOfPocketMax: '11000',
          coinsurance: '80',
          deductibleFamily: '3000',
          lifetimeMax: '500000',
          userCoinsurance: '20',
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-1000-11000-500000-20',
        oldPlanId: 250
      },
      '366': {
        planId: 366,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 2489.2,
              premium: 2608.9,
              initialPayment: 2628.85,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 434.82,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 553.09,
              premium: 573.04,
              initialPayment: 592.99,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 553.09,
                dailyPremium: 13.83,
                prepaidPremium: 2489.2
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 746.67,
              premium: 766.62,
              initialPayment: 786.57,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 746.67,
                dailyPremium: 18.67,
                prepaidPremium: 6795.52
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 598.44,
              premium: 618.39,
              initialPayment: 638.34,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 598.44,
                dailyPremium: 14.96,
                prepaidPremium: 2693.32
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 816.86,
              premium: 836.81,
              initialPayment: 856.76,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 816.86,
                dailyPremium: 20.42,
                prepaidPremium: 7434.3
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 863.9,
              premium: 883.85,
              initialPayment: 903.8,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 863.9,
                dailyPremium: 21.6,
                prepaidPremium: 7862.42
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          coinsurance: '80',
          userCoinsurance: '20',
          outOfPocketMax: '11000',
          lifetimeMax: '1000000',
          deductible: '1000',
          deductibleFamily: '3000',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-1000-11000-1000000-20',
        oldPlanId: 173
      },
      '368': {
        planId: 368,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1720.54,
              premium: 1840.24,
              initialPayment: 1860.19,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 306.71,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 382.3,
              premium: 402.25,
              initialPayment: 422.2,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 382.3,
                dailyPremium: 9.56,
                prepaidPremium: 1720.54
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 516.1,
              premium: 536.05,
              initialPayment: 556,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 516.1,
                dailyPremium: 12.9,
                prepaidPremium: 4697.07
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 413.64,
              premium: 433.59,
              initialPayment: 453.54,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 413.64,
                dailyPremium: 10.34,
                prepaidPremium: 1861.62
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 564.61,
              premium: 584.56,
              initialPayment: 604.51,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 564.61,
                dailyPremium: 14.12,
                prepaidPremium: 5138.59
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 597.13,
              premium: 617.08,
              initialPayment: 637.03,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 597.13,
                dailyPremium: 14.93,
                prepaidPremium: 5434.51
              }
            ]
          }
        ],
        coreBenefits: {
          outOfPocketMax: '11000',
          lifetimeMax: '100000',
          deductibleFamily: '3000',
          coinsurance: '70',
          deductible: '1000',
          userCoinsurance: '30',
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-1000-11000-100000-30',
        oldPlanId: 172
      },
      '369': {
        planId: 369,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 2007.29,
              premium: 2126.99,
              initialPayment: 2146.94,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 354.5,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 446.01,
              premium: 465.96,
              initialPayment: 485.91,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 446.01,
                dailyPremium: 11.15,
                prepaidPremium: 2007.29
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 602.12,
              premium: 622.07,
              initialPayment: 642.02,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 602.12,
                dailyPremium: 15.05,
                prepaidPremium: 5479.91
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 482.58,
              premium: 502.53,
              initialPayment: 522.48,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 482.58,
                dailyPremium: 12.07,
                prepaidPremium: 2171.89
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 658.71,
              premium: 678.66,
              initialPayment: 698.61,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 658.71,
                dailyPremium: 16.47,
                prepaidPremium: 5995.02
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 696.65,
              premium: 716.6,
              initialPayment: 736.55,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 696.65,
                dailyPremium: 17.42,
                prepaidPremium: 6340.26
              }
            ]
          }
        ],
        coreBenefits: {
          userCoinsurance: '30',
          coinsurance: '70',
          deductibleFamily: '3000',
          outOfPocketMax: '11000',
          lifetimeMax: '250000',
          deductible: '1000',
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-1000-11000-250000-30',
        oldPlanId: 174
      },
      '370': {
        planId: 370,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 2270.15,
              premium: 2389.85,
              initialPayment: 2409.8,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 398.31,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 504.42,
              premium: 524.37,
              initialPayment: 544.32,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 504.42,
                dailyPremium: 12.61,
                prepaidPremium: 2270.15
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 680.96,
              premium: 700.91,
              initialPayment: 720.86,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 680.96,
                dailyPremium: 17.03,
                prepaidPremium: 6197.52
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 545.78,
              premium: 565.73,
              initialPayment: 585.68,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 545.78,
                dailyPremium: 13.65,
                prepaidPremium: 2456.31
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 744.97,
              premium: 764.92,
              initialPayment: 784.87,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 744.97,
                dailyPremium: 18.63,
                prepaidPremium: 6780.08
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 787.88,
              premium: 807.83,
              initialPayment: 827.78,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 787.88,
                dailyPremium: 19.7,
                prepaidPremium: 7170.53
              }
            ]
          }
        ],
        coreBenefits: {
          outOfPocketMax: '11000',
          deductibleFamily: '3000',
          lifetimeMax: '500000',
          coinsurance: '70',
          deductible: '1000',
          userCoinsurance: '30',
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-1000-11000-500000-30',
        oldPlanId: null
      },
      '371': {
        planId: 371,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 2389.63,
              premium: 2509.33,
              initialPayment: 2529.28,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 418.22,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 530.97,
              premium: 550.92,
              initialPayment: 570.87,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 530.97,
                dailyPremium: 13.28,
                prepaidPremium: 2389.63
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 716.8,
              premium: 736.75,
              initialPayment: 756.7,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 716.8,
                dailyPremium: 17.92,
                prepaidPremium: 6523.7
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 574.51,
              premium: 594.46,
              initialPayment: 614.41,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 574.51,
                dailyPremium: 14.36,
                prepaidPremium: 2585.58
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 784.18,
              premium: 804.13,
              initialPayment: 824.08,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 784.18,
                dailyPremium: 19.61,
                prepaidPremium: 7136.93
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 829.34,
              premium: 849.29,
              initialPayment: 869.24,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 829.34,
                dailyPremium: 20.74,
                prepaidPremium: 7547.92
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          outOfPocketMax: '11000',
          coinsurance: '70',
          deductibleFamily: '3000',
          deductible: '1000',
          userCoinsurance: '30',
          lifetimeMax: '1000000',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-1000-11000-1000000-30',
        oldPlanId: null
      },
      '373': {
        planId: 373,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1388.98,
              premium: 1508.68,
              initialPayment: 1528.63,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 251.45,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 308.62,
              premium: 328.57,
              initialPayment: 348.52,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 308.62,
                dailyPremium: 7.72,
                prepaidPremium: 1388.98
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 416.64,
              premium: 436.59,
              initialPayment: 456.54,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 416.64,
                dailyPremium: 10.42,
                prepaidPremium: 3791.9
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 333.93,
              premium: 353.88,
              initialPayment: 373.83,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 333.93,
                dailyPremium: 8.35,
                prepaidPremium: 1502.87
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 455.81,
              premium: 475.76,
              initialPayment: 495.71,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 455.81,
                dailyPremium: 11.4,
                prepaidPremium: 4148.34
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 482.06,
              premium: 502.01,
              initialPayment: 521.96,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 482.06,
                dailyPremium: 12.05,
                prepaidPremium: 4387.23
              }
            ]
          }
        ],
        coreBenefits: {
          userCoinsurance: '20',
          lifetimeMax: '100000',
          deductible: '2000',
          coinsurance: '80',
          deductibleFamily: '6000',
          outOfPocketMax: '12000',
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-2000-12000-100000-20',
        oldPlanId: null
      },
      '374': {
        planId: 374,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1620.47,
              premium: 1740.17,
              initialPayment: 1760.12,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 290.03,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 360.06,
              premium: 380.01,
              initialPayment: 399.96,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 360.06,
                dailyPremium: 9,
                prepaidPremium: 1620.47
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 486.08,
              premium: 506.03,
              initialPayment: 525.98,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 486.08,
                dailyPremium: 12.15,
                prepaidPremium: 4423.89
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 389.59,
              premium: 409.54,
              initialPayment: 429.49,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 389.59,
                dailyPremium: 9.74,
                prepaidPremium: 1753.35
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 531.77,
              premium: 551.72,
              initialPayment: 571.67,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 531.77,
                dailyPremium: 13.3,
                prepaidPremium: 4839.73
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 562.4,
              premium: 582.35,
              initialPayment: 602.3,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 562.4,
                dailyPremium: 14.06,
                prepaidPremium: 5118.44
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          userCoinsurance: '20',
          deductible: '2000',
          deductibleFamily: '6000',
          coinsurance: '80',
          lifetimeMax: '250000',
          outOfPocketMax: '12000',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-2000-12000-250000-20',
        oldPlanId: 182
      },
      '375': {
        planId: 375,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1832.68,
              premium: 1952.38,
              initialPayment: 1972.33,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 325.4,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 407.21,
              premium: 427.16,
              initialPayment: 447.11,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 407.21,
                dailyPremium: 10.18,
                prepaidPremium: 1832.68
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 549.74,
              premium: 569.69,
              initialPayment: 589.64,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 549.74,
                dailyPremium: 13.75,
                prepaidPremium: 5003.2
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 440.6,
              premium: 460.55,
              initialPayment: 480.5,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 440.6,
                dailyPremium: 11.02,
                prepaidPremium: 1982.96
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 601.41,
              premium: 621.36,
              initialPayment: 641.31,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 601.41,
                dailyPremium: 15.04,
                prepaidPremium: 5473.51
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 636.05,
              premium: 656,
              initialPayment: 675.95,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 636.05,
                dailyPremium: 15.9,
                prepaidPremium: 5788.71
              }
            ]
          }
        ],
        coreBenefits: {
          deductible: '2000',
          outOfPocketMax: '12000',
          deductibleFamily: '6000',
          lifetimeMax: '500000',
          userCoinsurance: '20',
          coinsurance: '80',
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-2000-12000-500000-20',
        oldPlanId: 252
      },
      '376': {
        planId: 376,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1929.13,
              premium: 2048.83,
              initialPayment: 2068.78,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 341.47,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 428.64,
              premium: 448.59,
              initialPayment: 468.54,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 428.64,
                dailyPremium: 10.72,
                prepaidPremium: 1929.13
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 578.67,
              premium: 598.62,
              initialPayment: 618.57,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 578.67,
                dailyPremium: 14.47,
                prepaidPremium: 5266.53
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 463.79,
              premium: 483.74,
              initialPayment: 503.69,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 463.79,
                dailyPremium: 11.6,
                prepaidPremium: 2087.32
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 633.06,
              premium: 653.01,
              initialPayment: 672.96,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 633.06,
                dailyPremium: 15.83,
                prepaidPremium: 5761.58
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 669.52,
              premium: 689.47,
              initialPayment: 709.42,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 669.52,
                dailyPremium: 16.74,
                prepaidPremium: 6093.38
              }
            ]
          }
        ],
        coreBenefits: {
          deductibleFamily: '6000',
          coinsurance: '80',
          deductible: '2000',
          lifetimeMax: '1000000',
          outOfPocketMax: '12000',
          userCoinsurance: '20',
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-2000-12000-1000000-20',
        oldPlanId: 180
      },
      '378': {
        planId: 378,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1333.42,
              premium: 1453.12,
              initialPayment: 1473.07,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 242.19,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 296.28,
              premium: 316.23,
              initialPayment: 336.18,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 296.28,
                dailyPremium: 7.41,
                prepaidPremium: 1333.42
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 399.98,
              premium: 419.93,
              initialPayment: 439.88,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 399.98,
                dailyPremium: 10,
                prepaidPremium: 3640.23
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 320.57,
              premium: 340.52,
              initialPayment: 360.47,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 320.57,
                dailyPremium: 8.02,
                prepaidPremium: 1442.76
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 437.57,
              premium: 457.52,
              initialPayment: 477.47,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 437.57,
                dailyPremium: 10.94,
                prepaidPremium: 3982.41
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 462.77,
              premium: 482.72,
              initialPayment: 502.67,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 462.77,
                dailyPremium: 11.57,
                prepaidPremium: 4211.74
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          coinsurance: '70',
          deductibleFamily: '6000',
          userCoinsurance: '30',
          outOfPocketMax: '12000',
          deductible: '2000',
          lifetimeMax: '100000',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-2000-12000-100000-30',
        oldPlanId: 179
      },
      '379': {
        planId: 379,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1555.65,
              premium: 1675.35,
              initialPayment: 1695.3,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 279.22,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 345.66,
              premium: 365.61,
              initialPayment: 385.56,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 345.66,
                dailyPremium: 8.64,
                prepaidPremium: 1555.65
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 466.64,
              premium: 486.59,
              initialPayment: 506.54,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 466.64,
                dailyPremium: 11.67,
                prepaidPremium: 4246.93
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 374,
              premium: 393.95,
              initialPayment: 413.9,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 374,
                dailyPremium: 9.35,
                prepaidPremium: 1683.22
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 510.5,
              premium: 530.45,
              initialPayment: 550.4,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 510.5,
                dailyPremium: 12.76,
                prepaidPremium: 4646.14
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 539.9,
              premium: 559.85,
              initialPayment: 579.8,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 539.9,
                dailyPremium: 13.5,
                prepaidPremium: 4913.7
              }
            ]
          }
        ],
        coreBenefits: {
          deductibleFamily: '6000',
          userCoinsurance: '30',
          outOfPocketMax: '12000',
          coinsurance: '70',
          lifetimeMax: '250000',
          deductible: '2000',
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-2000-12000-250000-30',
        oldPlanId: 181
      },
      '380': {
        planId: 380,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1759.37,
              premium: 1879.07,
              initialPayment: 1899.02,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 313.18,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 390.92,
              premium: 410.87,
              initialPayment: 430.82,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 390.92,
                dailyPremium: 9.77,
                prepaidPremium: 1759.37
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 527.75,
              premium: 547.7,
              initialPayment: 567.65,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 527.75,
                dailyPremium: 13.2,
                prepaidPremium: 4803.08
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 422.98,
              premium: 442.93,
              initialPayment: 462.88,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 422.98,
                dailyPremium: 10.58,
                prepaidPremium: 1903.64
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 577.36,
              premium: 597.31,
              initialPayment: 617.26,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 577.36,
                dailyPremium: 14.44,
                prepaidPremium: 5254.57
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 610.6,
              premium: 630.55,
              initialPayment: 650.5,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 610.6,
                dailyPremium: 15.27,
                prepaidPremium: 5557.16
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          outOfPocketMax: '12000',
          deductibleFamily: '6000',
          lifetimeMax: '500000',
          deductible: '2000',
          coinsurance: '70',
          userCoinsurance: '30',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-2000-12000-500000-30',
        oldPlanId: null
      },
      '381': {
        planId: 381,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1851.97,
              premium: 1971.67,
              initialPayment: 1991.62,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 328.61,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 411.5,
              premium: 431.45,
              initialPayment: 451.4,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 411.5,
                dailyPremium: 10.29,
                prepaidPremium: 1851.97
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 555.52,
              premium: 575.47,
              initialPayment: 595.42,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 555.52,
                dailyPremium: 13.89,
                prepaidPremium: 5055.87
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 445.24,
              premium: 465.19,
              initialPayment: 485.14,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 445.24,
                dailyPremium: 11.13,
                prepaidPremium: 2003.83
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 607.74,
              premium: 627.69,
              initialPayment: 647.64,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 607.74,
                dailyPremium: 15.2,
                prepaidPremium: 5531.12
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 642.74,
              premium: 662.69,
              initialPayment: 682.64,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 642.74,
                dailyPremium: 16.07,
                prepaidPremium: 5849.64
              }
            ]
          }
        ],
        coreBenefits: {
          userCoinsurance: '30',
          outOfPocketMax: '12000',
          deductibleFamily: '6000',
          lifetimeMax: '1000000',
          coinsurance: '70',
          deductible: '2000',
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-2000-12000-1000000-30',
        oldPlanId: null
      },
      '383': {
        planId: 383,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 896.11,
              premium: 1015.81,
              initialPayment: 1035.76,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 169.3,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 199.11,
              premium: 219.06,
              initialPayment: 239.01,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 199.11,
                dailyPremium: 4.98,
                prepaidPremium: 896.11
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 268.8,
              premium: 288.75,
              initialPayment: 308.7,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 268.8,
                dailyPremium: 6.72,
                prepaidPremium: 2446.39
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 215.44,
              premium: 235.39,
              initialPayment: 255.34,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 215.44,
                dailyPremium: 5.39,
                prepaidPremium: 969.59
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 294.07,
              premium: 314.02,
              initialPayment: 333.97,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 294.07,
                dailyPremium: 7.35,
                prepaidPremium: 2676.35
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 311,
              premium: 330.95,
              initialPayment: 350.9,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 311,
                dailyPremium: 7.78,
                prepaidPremium: 2830.47
              }
            ]
          }
        ],
        coreBenefits: {
          lifetimeMax: '100000',
          coinsurance: '80',
          outOfPocketMax: '15000',
          deductible: '5000',
          deductibleFamily: '15000',
          userCoinsurance: '20',
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-5000-15000-100000-20',
        oldPlanId: null
      },
      '384': {
        planId: 384,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1045.47,
              premium: 1165.17,
              initialPayment: 1185.12,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 194.2,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 232.3,
              premium: 252.25,
              initialPayment: 272.2,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 232.3,
                dailyPremium: 5.81,
                prepaidPremium: 1045.47
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 313.6,
              premium: 333.55,
              initialPayment: 353.5,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 313.6,
                dailyPremium: 7.84,
                prepaidPremium: 2854.12
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 251.35,
              premium: 271.3,
              initialPayment: 291.25,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 251.35,
                dailyPremium: 6.28,
                prepaidPremium: 1131.19
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 343.08,
              premium: 363.03,
              initialPayment: 382.98,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 343.08,
                dailyPremium: 8.58,
                prepaidPremium: 3122.41
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 362.84,
              premium: 382.79,
              initialPayment: 402.74,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 362.84,
                dailyPremium: 9.07,
                prepaidPremium: 3302.22
              }
            ]
          }
        ],
        coreBenefits: {
          deductible: '5000',
          deductibleFamily: '15000',
          outOfPocketMax: '15000',
          coinsurance: '80',
          userCoinsurance: '20',
          lifetimeMax: '250000',
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-5000-15000-250000-20',
        oldPlanId: null
      },
      '385': {
        planId: 385,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1182.37,
              premium: 1302.07,
              initialPayment: 1322.02,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 217.01,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 262.72,
              premium: 282.67,
              initialPayment: 302.62,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 262.72,
                dailyPremium: 6.57,
                prepaidPremium: 1182.37
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 354.67,
              premium: 374.62,
              initialPayment: 394.57,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 354.67,
                dailyPremium: 8.87,
                prepaidPremium: 3227.87
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 284.26,
              premium: 304.21,
              initialPayment: 324.16,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 284.26,
                dailyPremium: 7.11,
                prepaidPremium: 1279.33
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 388.01,
              premium: 407.96,
              initialPayment: 427.91,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 388.01,
                dailyPremium: 9.7,
                prepaidPremium: 3531.29
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 410.35,
              premium: 430.3,
              initialPayment: 450.25,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 410.35,
                dailyPremium: 10.26,
                prepaidPremium: 3734.65
              }
            ]
          }
        ],
        coreBenefits: {
          lifetimeMax: '500000',
          userCoinsurance: '20',
          deductibleFamily: '15000',
          coinsurance: '80',
          deductible: '5000',
          outOfPocketMax: '15000',
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-5000-15000-500000-20',
        oldPlanId: 253
      },
      '386': {
        planId: 386,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1244.6,
              premium: 1364.3,
              initialPayment: 1384.25,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 227.38,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 276.54,
              premium: 296.49,
              initialPayment: 316.44,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 276.54,
                dailyPremium: 6.91,
                prepaidPremium: 1244.6
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 373.34,
              premium: 393.29,
              initialPayment: 413.24,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 373.34,
                dailyPremium: 9.33,
                prepaidPremium: 3397.76
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 299.22,
              premium: 319.17,
              initialPayment: 339.12,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 299.22,
                dailyPremium: 7.48,
                prepaidPremium: 1346.66
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 408.43,
              premium: 428.38,
              initialPayment: 448.33,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 408.43,
                dailyPremium: 10.21,
                prepaidPremium: 3717.15
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 431.95,
              premium: 451.9,
              initialPayment: 471.85,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 431.95,
                dailyPremium: 10.8,
                prepaidPremium: 3931.21
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          lifetimeMax: '1000000',
          deductible: '5000',
          userCoinsurance: '20',
          outOfPocketMax: '15000',
          deductibleFamily: '15000',
          coinsurance: '80',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-5000-15000-1000000-20',
        oldPlanId: 184
      },
      '388': {
        planId: 388,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 860.27,
              premium: 979.97,
              initialPayment: 999.92,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 163.33,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 191.15,
              premium: 211.1,
              initialPayment: 231.05,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 191.15,
                dailyPremium: 4.78,
                prepaidPremium: 860.27
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 258.05,
              premium: 278,
              initialPayment: 297.95,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 258.05,
                dailyPremium: 6.45,
                prepaidPremium: 2348.53
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 206.82,
              premium: 226.77,
              initialPayment: 246.72,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 206.82,
                dailyPremium: 5.17,
                prepaidPremium: 930.81
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 282.31,
              premium: 302.26,
              initialPayment: 322.21,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 282.31,
                dailyPremium: 7.06,
                prepaidPremium: 2569.3
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 298.56,
              premium: 318.51,
              initialPayment: 338.46,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 298.56,
                dailyPremium: 7.46,
                prepaidPremium: 2717.25
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          coinsurance: '70',
          outOfPocketMax: '15000',
          deductible: '5000',
          deductibleFamily: '15000',
          lifetimeMax: '100000',
          userCoinsurance: '30',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-5000-15000-100000-30',
        oldPlanId: 183
      },
      '389': {
        planId: 389,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1003.65,
              premium: 1123.35,
              initialPayment: 1143.3,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 187.22,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 223.01,
              premium: 242.96,
              initialPayment: 262.91,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 223.01,
                dailyPremium: 5.58,
                prepaidPremium: 1003.65
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 301.06,
              premium: 321.01,
              initialPayment: 340.96,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 301.06,
                dailyPremium: 7.53,
                prepaidPremium: 2739.96
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 241.29,
              premium: 261.24,
              initialPayment: 281.19,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 241.29,
                dailyPremium: 6.03,
                prepaidPremium: 1085.95
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 329.36,
              premium: 349.31,
              initialPayment: 369.26,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 329.36,
                dailyPremium: 8.23,
                prepaidPremium: 2997.51
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 348.32,
              premium: 368.27,
              initialPayment: 388.22,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 348.32,
                dailyPremium: 8.71,
                prepaidPremium: 3170.13
              }
            ]
          }
        ],
        coreBenefits: {
          outOfPocketMax: '15000',
          deductibleFamily: '15000',
          deductible: '5000',
          coinsurance: '70',
          lifetimeMax: '250000',
          userCoinsurance: '30',
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-5000-15000-250000-30',
        oldPlanId: 185
      },
      '390': {
        planId: 390,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1135.08,
              premium: 1254.78,
              initialPayment: 1274.73,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 209.13,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 252.21,
              premium: 272.16,
              initialPayment: 292.11,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 252.21,
                dailyPremium: 6.31,
                prepaidPremium: 1135.08
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 340.48,
              premium: 360.43,
              initialPayment: 380.38,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 340.48,
                dailyPremium: 8.51,
                prepaidPremium: 3098.76
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 272.89,
              premium: 292.84,
              initialPayment: 312.79,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 272.89,
                dailyPremium: 6.82,
                prepaidPremium: 1228.15
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 372.49,
              premium: 392.44,
              initialPayment: 412.39,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 372.49,
                dailyPremium: 9.31,
                prepaidPremium: 3390.04
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 393.94,
              premium: 413.89,
              initialPayment: 433.84,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 393.94,
                dailyPremium: 9.85,
                prepaidPremium: 3585.26
              }
            ]
          }
        ],
        coreBenefits: {
          deductible: '5000',
          lifetimeMax: '500000',
          deductibleFamily: '15000',
          coinsurance: '70',
          outOfPocketMax: '15000',
          userCoinsurance: '30',
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-5000-15000-500000-30',
        oldPlanId: null
      },
      '391': {
        planId: 391,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1194.82,
              premium: 1314.52,
              initialPayment: 1334.47,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 219.09,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 265.48,
              premium: 285.43,
              initialPayment: 305.38,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 265.48,
                dailyPremium: 6.64,
                prepaidPremium: 1194.82
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 358.4,
              premium: 378.35,
              initialPayment: 398.3,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 358.4,
                dailyPremium: 8.96,
                prepaidPremium: 3261.85
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 287.25,
              premium: 307.2,
              initialPayment: 327.15,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 287.25,
                dailyPremium: 7.18,
                prepaidPremium: 1292.79
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 392.09,
              premium: 412.04,
              initialPayment: 431.99,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 392.09,
                dailyPremium: 9.8,
                prepaidPremium: 3568.47
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 414.67,
              premium: 434.62,
              initialPayment: 454.57,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 414.67,
                dailyPremium: 10.37,
                prepaidPremium: 3773.96
              }
            ]
          }
        ],
        coreBenefits: {
          userCoinsurance: '30',
          coinsurance: '70',
          lifetimeMax: '1000000',
          outOfPocketMax: '15000',
          deductible: '5000',
          deductibleFamily: '150000',
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-5000-15000-1000000-30',
        oldPlanId: null
      },
      '393': {
        planId: 393,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 716.89,
              premium: 836.59,
              initialPayment: 856.54,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 139.43,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 159.29,
              premium: 179.24,
              initialPayment: 199.19,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 159.29,
                dailyPremium: 3.98,
                prepaidPremium: 716.89
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 215.04,
              premium: 234.99,
              initialPayment: 254.94,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 215.04,
                dailyPremium: 5.38,
                prepaidPremium: 1957.11
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 172.35,
              premium: 192.3,
              initialPayment: 212.25,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 172.35,
                dailyPremium: 4.31,
                prepaidPremium: 775.68
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 235.26,
              premium: 255.21,
              initialPayment: 275.16,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 235.26,
                dailyPremium: 5.88,
                prepaidPremium: 2141.08
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 248.8,
              premium: 268.75,
              initialPayment: 288.7,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 248.8,
                dailyPremium: 6.22,
                prepaidPremium: 2264.38
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          deductibleFamily: '30000',
          outOfPocketMax: '20000',
          userCoinsurance: '20',
          coinsurance: '80',
          lifetimeMax: '100000',
          deductible: '10000',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-10000-20000-100000-20',
        oldPlanId: null
      },
      '394': {
        planId: 394,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 836.37,
              premium: 956.07,
              initialPayment: 976.02,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 159.34,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 185.84,
              premium: 205.79,
              initialPayment: 225.74,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 185.84,
                dailyPremium: 4.65,
                prepaidPremium: 836.37
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 250.88,
              premium: 270.83,
              initialPayment: 290.78,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 250.88,
                dailyPremium: 6.27,
                prepaidPremium: 2283.3
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 201.08,
              premium: 221.03,
              initialPayment: 240.98,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 201.08,
                dailyPremium: 5.03,
                prepaidPremium: 904.95
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 274.46,
              premium: 294.41,
              initialPayment: 314.36,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 274.46,
                dailyPremium: 6.86,
                prepaidPremium: 2497.93
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 290.27,
              premium: 310.22,
              initialPayment: 330.17,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 290.27,
                dailyPremium: 7.26,
                prepaidPremium: 2641.77
              }
            ]
          }
        ],
        coreBenefits: {
          userCoinsurance: '20',
          lifetimeMax: '250000',
          coinsurance: '80',
          deductible: '10000',
          outOfPocketMax: '20000',
          deductibleFamily: '30000',
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-10000-20000-250000-20',
        oldPlanId: 178
      },
      '395': {
        planId: 395,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 945.9,
              premium: 1065.6,
              initialPayment: 1085.55,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 177.6,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 210.17,
              premium: 230.12,
              initialPayment: 250.07,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 210.17,
                dailyPremium: 5.25,
                prepaidPremium: 945.9
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 283.73,
              premium: 303.68,
              initialPayment: 323.63,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 283.73,
                dailyPremium: 7.09,
                prepaidPremium: 2582.3
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 227.41,
              premium: 247.36,
              initialPayment: 267.31,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 227.41,
                dailyPremium: 5.69,
                prepaidPremium: 1023.46
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 310.41,
              premium: 330.36,
              initialPayment: 350.31,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 310.41,
                dailyPremium: 7.76,
                prepaidPremium: 2825.04
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 328.28,
              premium: 348.23,
              initialPayment: 368.18,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 328.28,
                dailyPremium: 8.21,
                prepaidPremium: 2987.72
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          deductibleFamily: '30000',
          lifetimeMax: '500000',
          outOfPocketMax: '20000',
          deductible: '10000',
          userCoinsurance: '20',
          coinsurance: '80',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-10000-20000-500000-20',
        oldPlanId: 251
      },
      '396': {
        planId: 396,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 995.68,
              premium: 1115.38,
              initialPayment: 1135.33,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 185.9,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 221.24,
              premium: 241.19,
              initialPayment: 261.14,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 221.24,
                dailyPremium: 5.53,
                prepaidPremium: 995.68
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 298.67,
              premium: 318.62,
              initialPayment: 338.57,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 298.67,
                dailyPremium: 7.47,
                prepaidPremium: 2718.21
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 239.38,
              premium: 259.33,
              initialPayment: 279.28,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 239.38,
                dailyPremium: 5.99,
                prepaidPremium: 1077.33
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 326.74,
              premium: 346.69,
              initialPayment: 366.64,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 326.74,
                dailyPremium: 8.17,
                prepaidPremium: 2973.72
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 345.56,
              premium: 365.51,
              initialPayment: 385.46,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 345.56,
                dailyPremium: 8.64,
                prepaidPremium: 3144.97
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          coinsurance: '80',
          userCoinsurance: '20',
          deductibleFamily: '30000',
          outOfPocketMax: '20000',
          lifetimeMax: '1000000',
          deductible: '10000',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-10000-20000-1000000-20',
        oldPlanId: 176
      },
      '398': {
        planId: 398,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 688.21,
              premium: 807.91,
              initialPayment: 827.86,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 134.65,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 152.92,
              premium: 172.87,
              initialPayment: 192.82,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 152.92,
                dailyPremium: 3.82,
                prepaidPremium: 688.21
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 206.44,
              premium: 226.39,
              initialPayment: 246.34,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 206.44,
                dailyPremium: 5.16,
                prepaidPremium: 1878.83
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 165.46,
              premium: 185.41,
              initialPayment: 205.36,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 165.46,
                dailyPremium: 4.14,
                prepaidPremium: 744.65
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 225.84,
              premium: 245.79,
              initialPayment: 265.74,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 225.84,
                dailyPremium: 5.65,
                prepaidPremium: 2055.44
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 238.85,
              premium: 258.8,
              initialPayment: 278.75,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 238.85,
                dailyPremium: 5.97,
                prepaidPremium: 2173.8
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          lifetimeMax: '100000',
          outOfPocketMax: '20000',
          userCoinsurance: '30',
          deductible: '10000',
          coinsurance: '70',
          deductibleFamily: '30000',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-10000-20000-100000-30',
        oldPlanId: 175
      },
      '399': {
        planId: 399,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 802.92,
              premium: 922.62,
              initialPayment: 942.57,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 153.77,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 178.4,
              premium: 198.35,
              initialPayment: 218.3,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 178.4,
                dailyPremium: 4.46,
                prepaidPremium: 802.92
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 240.85,
              premium: 260.8,
              initialPayment: 280.75,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 240.85,
                dailyPremium: 6.02,
                prepaidPremium: 2191.96
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 193.03,
              premium: 212.98,
              initialPayment: 232.93,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 193.03,
                dailyPremium: 4.83,
                prepaidPremium: 868.76
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 263.49,
              premium: 283.44,
              initialPayment: 303.39,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 263.49,
                dailyPremium: 6.59,
                prepaidPremium: 2398.01
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 278.66,
              premium: 298.61,
              initialPayment: 318.56,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 278.66,
                dailyPremium: 6.97,
                prepaidPremium: 2536.1
              }
            ]
          }
        ],
        coreBenefits: {
          outOfPocketMax: '20000',
          coinsurance: '70',
          deductibleFamily: '30000',
          lifetimeMax: '250000',
          deductible: '10000',
          userCoinsurance: '30',
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-10000-20000-250000-30',
        oldPlanId: 177
      },
      '400': {
        planId: 400,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 908.06,
              premium: 1027.76,
              initialPayment: 1047.71,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 171.29,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 201.77,
              premium: 221.72,
              initialPayment: 241.67,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 201.77,
                dailyPremium: 5.04,
                prepaidPremium: 908.06
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 272.39,
              premium: 292.34,
              initialPayment: 312.29,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 272.39,
                dailyPremium: 6.81,
                prepaidPremium: 2479.01
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 218.31,
              premium: 238.26,
              initialPayment: 258.21,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 218.31,
                dailyPremium: 5.46,
                prepaidPremium: 982.52
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 297.99,
              premium: 317.94,
              initialPayment: 337.89,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 297.99,
                dailyPremium: 7.45,
                prepaidPremium: 2712.03
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 315.15,
              premium: 335.1,
              initialPayment: 355.05,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 315.15,
                dailyPremium: 7.88,
                prepaidPremium: 2868.21
              }
            ]
          }
        ],
        coreBenefits: {
          userCoinsurance: '30',
          deductible: '10000',
          lifetimeMax: '500000',
          outOfPocketMax: '20000',
          deductibleFamily: '30000',
          coinsurance: '70',
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-10000-20000-500000-30',
        oldPlanId: null
      },
      '401': {
        planId: 401,
        productId: 16,
        brochureId: 4,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Choice',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 955.85,
              premium: 1075.55,
              initialPayment: 1095.5,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 179.26,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 212.39,
              premium: 232.34,
              initialPayment: 252.29,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 212.39,
                dailyPremium: 5.31,
                prepaidPremium: 955.85
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 286.72,
              premium: 306.67,
              initialPayment: 326.62,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 286.72,
                dailyPremium: 7.17,
                prepaidPremium: 2609.48
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 229.8,
              premium: 249.75,
              initialPayment: 269.7,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 229.8,
                dailyPremium: 5.75,
                prepaidPremium: 1034.23
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 313.67,
              premium: 333.62,
              initialPayment: 353.57,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 313.67,
                dailyPremium: 7.84,
                prepaidPremium: 2854.77
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 331.74,
              premium: 351.69,
              initialPayment: 371.64,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 331.74,
                dailyPremium: 8.29,
                prepaidPremium: 3019.17
              }
            ]
          }
        ],
        coreBenefits: {
          coinsurance: '70',
          lifetimeMax: '1000000',
          outOfPocketMax: '20000',
          deductibleFamily: '30000',
          userCoinsurance: '30',
          deductible: '10000',
          officeVisitCopay: '$30/$60/$60',
          network: 'Non-PPO',
          urgentCareCopay: '60',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          rxSchedule: '01',
          emergencyRoomCopay: '250',
          outpatientFacilityCopay: '0',
          patientAdvocacyServices: 'true',
          officeVisitCopayFrequencyLimitation: '3',
          inpatientCopay: '0',
          officeVisitCopayUrgentCare: '60',
          officeVisitCopayGeneralPractitioner: '30',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-CHO-10000-20000-1000000-30',
        oldPlanId: null
      },
      '403': {
        planId: 403,
        productId: 14,
        brochureId: 9,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Deluxe',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 3062.97,
              premium: 3182.67,
              initialPayment: 3202.62,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 530.44,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 680.55,
              premium: 700.5,
              initialPayment: 720.45,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 680.55,
                dailyPremium: 17.02,
                prepaidPremium: 3062.97
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 918.75,
              premium: 938.7,
              initialPayment: 958.65,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 918.75,
                dailyPremium: 22.97,
                prepaidPremium: 8361.91
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 736.36,
              premium: 756.31,
              initialPayment: 776.26,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 736.36,
                dailyPremium: 18.41,
                prepaidPremium: 3314.13
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 1005.11,
              premium: 1025.06,
              initialPayment: 1045.01,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 1005.11,
                dailyPremium: 25.13,
                prepaidPremium: 9147.93
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 1062.99,
              premium: 1082.94,
              initialPayment: 1102.89,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 1062.99,
                dailyPremium: 26.58,
                prepaidPremium: 9674.73
              }
            ]
          }
        ],
        coreBenefits: {
          outOfPocketMax: '4000',
          deductibleFamily: '3000',
          deductible: '1000',
          lifetimeMax: '500000',
          urgentCareCopay: '60',
          inpatientCopay: '0',
          officeVisitCopay: '$30/$60/$60',
          rxSchedule: '05',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          network: 'Non-PPO',
          officeVisitCopayFrequencyLimitation: '3',
          officeVisitCopayGeneralPractitioner: '30',
          userCoinsurance: '20',
          officeVisitCopayUrgentCare: '60',
          patientAdvocacyServices: 'true',
          outpatientFacilityCopay: '0',
          coinsurance: '80',
          emergencyRoomCopay: '250',
          rxScheduleDescription:
            '$10/$30/$75 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'CLIC-STM-DLX-1000-4000-500000-20',
        oldPlanId: 189
      },
      '404': {
        planId: 404,
        productId: 14,
        brochureId: 9,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Deluxe',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 3204.4,
              premium: 3324.1,
              initialPayment: 3344.05,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 554.02,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 711.98,
              premium: 731.93,
              initialPayment: 751.88,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 711.98,
                dailyPremium: 17.8,
                prepaidPremium: 3204.4
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 961.17,
              premium: 981.12,
              initialPayment: 1001.07,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 961.17,
                dailyPremium: 24.03,
                prepaidPremium: 8748.02
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 770.36,
              premium: 790.31,
              initialPayment: 810.26,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 770.36,
                dailyPremium: 19.26,
                prepaidPremium: 3467.16
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 1051.52,
              premium: 1071.47,
              initialPayment: 1091.42,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 1051.52,
                dailyPremium: 26.29,
                prepaidPremium: 9570.33
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 1112.07,
              premium: 1132.02,
              initialPayment: 1151.97,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 1112.07,
                dailyPremium: 27.81,
                prepaidPremium: 10121.46
              }
            ]
          }
        ],
        coreBenefits: {
          urgentCareCopay: '60',
          inpatientCopay: '0',
          officeVisitCopay: '$30/$60/$60',
          rxSchedule: '05',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          network: 'Non-PPO',
          officeVisitCopayFrequencyLimitation: '3',
          officeVisitCopayGeneralPractitioner: '30',
          userCoinsurance: '20',
          officeVisitCopayUrgentCare: '60',
          patientAdvocacyServices: 'true',
          outpatientFacilityCopay: '0',
          coinsurance: '80',
          emergencyRoomCopay: '250',
          deductibleFamily: '3000',
          outOfPocketMax: '4000',
          lifetimeMax: '1000000',
          deductible: '1000',
          rxScheduleDescription:
            '$10/$30/$75 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'CLIC-STM-DLX-1000-4000-1000000-20',
        oldPlanId: 188
      },
      '406': {
        planId: 406,
        productId: 14,
        brochureId: 9,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Deluxe',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 2256.81,
              premium: 2376.51,
              initialPayment: 2396.46,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 396.08,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 501.43,
              premium: 521.38,
              initialPayment: 541.33,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 501.43,
                dailyPremium: 12.54,
                prepaidPremium: 2256.81
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 676.93,
              premium: 696.88,
              initialPayment: 716.83,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 676.93,
                dailyPremium: 16.93,
                prepaidPremium: 6161.09
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 542.54,
              premium: 562.49,
              initialPayment: 582.44,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 542.54,
                dailyPremium: 13.57,
                prepaidPremium: 2441.87
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 740.56,
              premium: 760.51,
              initialPayment: 780.46,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 740.56,
                dailyPremium: 18.52,
                prepaidPremium: 6740.23
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 783.2,
              premium: 803.15,
              initialPayment: 823.1,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 783.2,
                dailyPremium: 19.58,
                prepaidPremium: 7128.38
              }
            ]
          }
        ],
        coreBenefits: {
          urgentCareCopay: '60',
          inpatientCopay: '0',
          officeVisitCopay: '$30/$60/$60',
          rxSchedule: '05',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          network: 'Non-PPO',
          officeVisitCopayFrequencyLimitation: '3',
          officeVisitCopayGeneralPractitioner: '30',
          userCoinsurance: '20',
          officeVisitCopayUrgentCare: '60',
          patientAdvocacyServices: 'true',
          outpatientFacilityCopay: '0',
          coinsurance: '80',
          emergencyRoomCopay: '250',
          outOfPocketMax: '5500',
          lifetimeMax: '500000',
          deductible: '2500',
          deductibleFamily: '7500',
          rxScheduleDescription:
            '$10/$30/$75 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'CLIC-STM-DLX-2500-5500-500000-20',
        oldPlanId: 191
      },
      '407': {
        planId: 407,
        productId: 14,
        brochureId: 9,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Deluxe',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 2355.81,
              premium: 2475.51,
              initialPayment: 2495.46,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 412.58,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 523.42,
              premium: 543.37,
              initialPayment: 563.32,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 523.42,
                dailyPremium: 13.09,
                prepaidPremium: 2355.81
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 706.62,
              premium: 726.57,
              initialPayment: 746.52,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 706.62,
                dailyPremium: 17.67,
                prepaidPremium: 6431.36
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 566.35,
              premium: 586.3,
              initialPayment: 606.25,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 566.35,
                dailyPremium: 14.16,
                prepaidPremium: 2548.99
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 773.05,
              premium: 793,
              initialPayment: 812.95,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 773.05,
                dailyPremium: 19.33,
                prepaidPremium: 7035.91
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 817.56,
              premium: 837.51,
              initialPayment: 857.46,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 817.56,
                dailyPremium: 20.44,
                prepaidPremium: 7441.09
              }
            ]
          }
        ],
        coreBenefits: {
          urgentCareCopay: '60',
          inpatientCopay: '0',
          officeVisitCopay: '$30/$60/$60',
          rxSchedule: '05',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          network: 'Non-PPO',
          officeVisitCopayFrequencyLimitation: '3',
          officeVisitCopayGeneralPractitioner: '30',
          userCoinsurance: '20',
          officeVisitCopayUrgentCare: '60',
          patientAdvocacyServices: 'true',
          outpatientFacilityCopay: '0',
          coinsurance: '80',
          emergencyRoomCopay: '250',
          deductible: '2500',
          lifetimeMax: '1000000',
          outOfPocketMax: '5500',
          deductibleFamily: '7500',
          rxScheduleDescription:
            '$10/$30/$75 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'CLIC-STM-DLX-2500-5500-1000000-20',
        oldPlanId: 190
      },
      '409': {
        planId: 409,
        productId: 14,
        brochureId: 9,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Deluxe',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1719.37,
              premium: 1839.07,
              initialPayment: 1859.02,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 306.51,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 382.01,
              premium: 401.96,
              initialPayment: 421.91,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 382.01,
                dailyPremium: 9.55,
                prepaidPremium: 1719.37
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 515.71,
              premium: 535.66,
              initialPayment: 555.61,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 515.71,
                dailyPremium: 12.9,
                prepaidPremium: 4693.87
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 413.33,
              premium: 433.28,
              initialPayment: 453.23,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 413.33,
                dailyPremium: 10.34,
                prepaidPremium: 1860.36
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 564.19,
              premium: 584.14,
              initialPayment: 604.09,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 564.19,
                dailyPremium: 14.11,
                prepaidPremium: 5135.1
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 596.68,
              premium: 616.63,
              initialPayment: 636.58,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 596.68,
                dailyPremium: 14.92,
                prepaidPremium: 5430.81
              }
            ]
          }
        ],
        coreBenefits: {
          urgentCareCopay: '60',
          inpatientCopay: '0',
          officeVisitCopay: '$30/$60/$60',
          rxSchedule: '05',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          network: 'Non-PPO',
          officeVisitCopayFrequencyLimitation: '3',
          officeVisitCopayGeneralPractitioner: '30',
          userCoinsurance: '20',
          officeVisitCopayUrgentCare: '60',
          patientAdvocacyServices: 'true',
          outpatientFacilityCopay: '0',
          coinsurance: '80',
          emergencyRoomCopay: '250',
          deductible: '5000',
          deductibleFamily: '15000',
          lifetimeMax: '500000',
          outOfPocketMax: '8000',
          rxScheduleDescription:
            '$10/$30/$75 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'CLIC-STM-DLX-5000-8000-500000-20',
        oldPlanId: 193
      },
      '410': {
        planId: 410,
        productId: 14,
        brochureId: 9,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Deluxe',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1790.08,
              premium: 1909.78,
              initialPayment: 1929.73,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 318.3,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 397.72,
              premium: 417.67,
              initialPayment: 437.62,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 397.72,
                dailyPremium: 9.94,
                prepaidPremium: 1790.08
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 536.93,
              premium: 556.88,
              initialPayment: 576.83,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 536.93,
                dailyPremium: 13.43,
                prepaidPremium: 4886.93
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 430.34,
              premium: 450.29,
              initialPayment: 470.24,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 430.34,
                dailyPremium: 10.76,
                prepaidPremium: 1936.87
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 587.4,
              premium: 607.35,
              initialPayment: 627.3,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 587.4,
                dailyPremium: 14.69,
                prepaidPremium: 5346.3
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 621.22,
              premium: 641.17,
              initialPayment: 661.12,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 621.22,
                dailyPremium: 15.53,
                prepaidPremium: 5654.17
              }
            ]
          }
        ],
        coreBenefits: {
          urgentCareCopay: '60',
          inpatientCopay: '0',
          officeVisitCopay: '$30/$60/$60',
          rxSchedule: '05',
          networkProvider: 'any-provider',
          officeVisitCopaySpecialist: '60',
          network: 'Non-PPO',
          officeVisitCopayFrequencyLimitation: '3',
          officeVisitCopayGeneralPractitioner: '30',
          userCoinsurance: '20',
          officeVisitCopayUrgentCare: '60',
          patientAdvocacyServices: 'true',
          outpatientFacilityCopay: '0',
          coinsurance: '80',
          emergencyRoomCopay: '250',
          outOfPocketMax: '8000',
          deductible: '5000',
          deductibleFamily: '15000',
          lifetimeMax: '1000000',
          rxScheduleDescription:
            '$10/$30/$75 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'CLIC-STM-DLX-5000-8000-1000000-20',
        oldPlanId: 192
      },
      '448': {
        planId: 448,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 973.54,
              premium: 1093.24,
              initialPayment: 1113.19,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 182.21,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 216.32,
              premium: 236.27,
              initialPayment: 256.22,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 216.32,
                dailyPremium: 5.41,
                prepaidPremium: 973.54
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 292.03,
              premium: 311.98,
              initialPayment: 331.93,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 292.03,
                dailyPremium: 7.3,
                prepaidPremium: 2657.76
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 234.05,
              premium: 254,
              initialPayment: 273.95,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 234.05,
                dailyPremium: 5.85,
                prepaidPremium: 1053.37
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 319.48,
              premium: 339.43,
              initialPayment: 359.38,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 319.48,
                dailyPremium: 7.99,
                prepaidPremium: 2907.59
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 337.87,
              premium: 357.82,
              initialPayment: 377.77,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 337.87,
                dailyPremium: 8.45,
                prepaidPremium: 3075.02
              }
            ]
          }
        ],
        coreBenefits: {
          deductible: '3000',
          outOfPocketMax: '13000',
          lifetimeMax: '100000',
          coinsurance: '80',
          userCoinsurance: '20',
          deductibleFamily: '9000',
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-3000-13000-100000-20',
        oldPlanId: null
      },
      '449': {
        planId: 449,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1135.79,
              premium: 1255.49,
              initialPayment: 1275.44,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 209.25,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 252.37,
              premium: 272.32,
              initialPayment: 292.27,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 252.37,
                dailyPremium: 6.31,
                prepaidPremium: 1135.79
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 340.7,
              premium: 360.65,
              initialPayment: 380.6,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 340.7,
                dailyPremium: 8.52,
                prepaidPremium: 3100.72
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 273.06,
              premium: 293.01,
              initialPayment: 312.96,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 273.06,
                dailyPremium: 6.83,
                prepaidPremium: 1228.93
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 372.72,
              premium: 392.67,
              initialPayment: 412.62,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 372.72,
                dailyPremium: 9.32,
                prepaidPremium: 3392.18
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 394.19,
              premium: 414.14,
              initialPayment: 434.09,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 394.19,
                dailyPremium: 9.86,
                prepaidPremium: 3587.53
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          coinsurance: '80',
          lifetimeMax: '250000',
          outOfPocketMax: '13000',
          deductible: '3000',
          userCoinsurance: '20',
          deductibleFamily: '9000',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-3000-13000-250000-20',
        oldPlanId: null
      },
      '450': {
        planId: 450,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1284.53,
              premium: 1404.23,
              initialPayment: 1424.18,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 234.04,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 285.42,
              premium: 305.37,
              initialPayment: 325.32,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 285.42,
                dailyPremium: 7.14,
                prepaidPremium: 1284.53
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 385.31,
              premium: 405.26,
              initialPayment: 425.21,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 385.31,
                dailyPremium: 9.63,
                prepaidPremium: 3506.76
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 308.82,
              premium: 328.77,
              initialPayment: 348.72,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 308.82,
                dailyPremium: 7.72,
                prepaidPremium: 1389.86
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 421.53,
              premium: 441.48,
              initialPayment: 461.43,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 421.53,
                dailyPremium: 10.54,
                prepaidPremium: 3836.4
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 445.81,
              premium: 465.76,
              initialPayment: 485.71,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 445.81,
                dailyPremium: 11.15,
                prepaidPremium: 4057.32
              }
            ]
          }
        ],
        coreBenefits: {
          lifetimeMax: '500000',
          deductible: '3000',
          coinsurance: '80',
          deductibleFamily: '9000',
          outOfPocketMax: '13000',
          userCoinsurance: '20',
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-3000-13000-500000-20',
        oldPlanId: null
      },
      '451': {
        planId: 451,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1352.14,
              premium: 1471.84,
              initialPayment: 1491.79,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 245.31,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 300.44,
              premium: 320.39,
              initialPayment: 340.34,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 300.44,
                dailyPremium: 7.51,
                prepaidPremium: 1352.14
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 405.59,
              premium: 425.54,
              initialPayment: 445.49,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 405.59,
                dailyPremium: 10.14,
                prepaidPremium: 3691.33
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 325.07,
              premium: 345.02,
              initialPayment: 364.97,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 325.07,
                dailyPremium: 8.13,
                prepaidPremium: 1463.01
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 443.72,
              premium: 463.67,
              initialPayment: 483.62,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 443.72,
                dailyPremium: 11.09,
                prepaidPremium: 4038.31
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 469.27,
              premium: 489.22,
              initialPayment: 509.17,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 469.27,
                dailyPremium: 11.73,
                prepaidPremium: 4270.87
              }
            ]
          }
        ],
        coreBenefits: {
          deductibleFamily: '9000',
          outOfPocketMax: '13000',
          userCoinsurance: '20',
          lifetimeMax: '1000000',
          coinsurance: '80',
          deductible: '3000',
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-3000-13000-1000000-20',
        oldPlanId: null
      },
      '452': {
        planId: 452,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 934.6,
              premium: 1054.3,
              initialPayment: 1074.25,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 175.72,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 207.66,
              premium: 227.61,
              initialPayment: 247.56,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 207.66,
                dailyPremium: 5.19,
                prepaidPremium: 934.6
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 280.34,
              premium: 300.29,
              initialPayment: 320.24,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 280.34,
                dailyPremium: 7.01,
                prepaidPremium: 2551.45
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 224.69,
              premium: 244.64,
              initialPayment: 264.59,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 224.69,
                dailyPremium: 5.62,
                prepaidPremium: 1011.23
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 306.7,
              premium: 326.65,
              initialPayment: 346.6,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 306.7,
                dailyPremium: 7.67,
                prepaidPremium: 2791.28
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 324.36,
              premium: 344.31,
              initialPayment: 364.26,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 324.36,
                dailyPremium: 8.11,
                prepaidPremium: 2952.02
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          deductible: '3000',
          userCoinsurance: '30',
          coinsurance: '70',
          lifetimeMax: '100000',
          deductibleFamily: '9000',
          outOfPocketMax: '13000',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-3000-13000-100000-30',
        oldPlanId: 199
      },
      '453': {
        planId: 453,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1090.36,
              premium: 1210.06,
              initialPayment: 1230.01,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 201.68,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 242.27,
              premium: 262.22,
              initialPayment: 282.17,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 242.27,
                dailyPremium: 6.06,
                prepaidPremium: 1090.36
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 327.07,
              premium: 347.02,
              initialPayment: 366.97,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 327.07,
                dailyPremium: 8.18,
                prepaidPremium: 2976.69
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 262.14,
              premium: 282.09,
              initialPayment: 302.04,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 262.14,
                dailyPremium: 6.55,
                prepaidPremium: 1179.77
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 357.81,
              premium: 377.76,
              initialPayment: 397.71,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 357.81,
                dailyPremium: 8.95,
                prepaidPremium: 3256.5
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 378.42,
              premium: 398.37,
              initialPayment: 418.32,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 378.42,
                dailyPremium: 9.46,
                prepaidPremium: 3444.03
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          deductible: '3000',
          deductibleFamily: '9000',
          outOfPocketMax: '13000',
          userCoinsurance: '30',
          coinsurance: '70',
          lifetimeMax: '250000',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-3000-13000-250000-30',
        oldPlanId: null
      },
      '454': {
        planId: 454,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1233.15,
              premium: 1352.85,
              initialPayment: 1372.8,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 225.48,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 274,
              premium: 293.95,
              initialPayment: 313.9,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 274,
                dailyPremium: 6.85,
                prepaidPremium: 1233.15
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 369.9,
              premium: 389.85,
              initialPayment: 409.8,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 369.9,
                dailyPremium: 9.25,
                prepaidPremium: 3366.49
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 296.47,
              premium: 316.42,
              initialPayment: 336.37,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 296.47,
                dailyPremium: 7.41,
                prepaidPremium: 1334.27
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 404.67,
              premium: 424.62,
              initialPayment: 444.57,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 404.67,
                dailyPremium: 10.12,
                prepaidPremium: 3682.94
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 427.97,
              premium: 447.92,
              initialPayment: 467.87,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 427.97,
                dailyPremium: 10.7,
                prepaidPremium: 3895.03
              }
            ]
          }
        ],
        coreBenefits: {
          lifetimeMax: '500000',
          outOfPocketMax: '13000',
          coinsurance: '70',
          deductible: '3000',
          userCoinsurance: '30',
          deductibleFamily: '9000',
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-3000-13000-500000-30',
        oldPlanId: 200
      },
      '455': {
        planId: 455,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1298.05,
              premium: 1417.75,
              initialPayment: 1437.7,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 236.29,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 288.42,
              premium: 308.37,
              initialPayment: 328.32,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 288.42,
                dailyPremium: 7.21,
                prepaidPremium: 1298.05
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 389.37,
              premium: 409.32,
              initialPayment: 429.27,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 389.37,
                dailyPremium: 9.74,
                prepaidPremium: 3543.68
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 312.07,
              premium: 332.02,
              initialPayment: 351.97,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 312.07,
                dailyPremium: 7.8,
                prepaidPremium: 1404.49
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 425.97,
              premium: 445.92,
              initialPayment: 465.87,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 425.97,
                dailyPremium: 10.65,
                prepaidPremium: 3876.78
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 450.5,
              premium: 470.45,
              initialPayment: 490.4,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 450.5,
                dailyPremium: 11.26,
                prepaidPremium: 4100.03
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          outOfPocketMax: '13000',
          deductible: '3000',
          deductibleFamily: '9000',
          userCoinsurance: '30',
          coinsurance: '70',
          lifetimeMax: '1000000',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-3000-13000-1000000-30',
        oldPlanId: 254
      },
      '456': {
        planId: 456,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 778.83,
              premium: 898.53,
              initialPayment: 918.48,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 149.76,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 173.05,
              premium: 193,
              initialPayment: 212.95,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 173.05,
                dailyPremium: 4.33,
                prepaidPremium: 778.83
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 233.62,
              premium: 253.57,
              initialPayment: 273.52,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 233.62,
                dailyPremium: 5.84,
                prepaidPremium: 2126.21
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 187.24,
              premium: 207.19,
              initialPayment: 227.14,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 187.24,
                dailyPremium: 4.68,
                prepaidPremium: 842.69
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 255.58,
              premium: 275.53,
              initialPayment: 295.48,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 255.58,
                dailyPremium: 6.39,
                prepaidPremium: 2326.07
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 270.3,
              premium: 290.25,
              initialPayment: 310.2,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 270.3,
                dailyPremium: 6.76,
                prepaidPremium: 2460.02
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          userCoinsurance: '20',
          deductible: '5000',
          outOfPocketMax: '15000',
          coinsurance: '80',
          deductibleFamily: '15000',
          lifetimeMax: '100000',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-5000-15000-100000-20',
        oldPlanId: 202
      },
      '457': {
        planId: 457,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 908.63,
              premium: 1028.33,
              initialPayment: 1048.28,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 171.39,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 201.89,
              premium: 221.84,
              initialPayment: 241.79,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 201.89,
                dailyPremium: 5.05,
                prepaidPremium: 908.63
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 272.56,
              premium: 292.51,
              initialPayment: 312.46,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 272.56,
                dailyPremium: 6.81,
                prepaidPremium: 2480.57
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 218.45,
              premium: 238.4,
              initialPayment: 258.35,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 218.45,
                dailyPremium: 5.46,
                prepaidPremium: 983.14
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 298.18,
              premium: 318.13,
              initialPayment: 338.08,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 298.18,
                dailyPremium: 7.46,
                prepaidPremium: 2713.75
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 315.35,
              premium: 335.3,
              initialPayment: 355.25,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 315.35,
                dailyPremium: 7.88,
                prepaidPremium: 2870.02
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          deductibleFamily: '15000',
          userCoinsurance: '20',
          coinsurance: '80',
          deductible: '5000',
          outOfPocketMax: '15000',
          lifetimeMax: '250000',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-5000-15000-250000-20',
        oldPlanId: null
      },
      '458': {
        planId: 458,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1027.62,
              premium: 1147.32,
              initialPayment: 1167.27,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 191.22,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 228.33,
              premium: 248.28,
              initialPayment: 268.23,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 228.33,
                dailyPremium: 5.71,
                prepaidPremium: 1027.62
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 308.25,
              premium: 328.2,
              initialPayment: 348.15,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 308.25,
                dailyPremium: 7.71,
                prepaidPremium: 2805.41
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 247.06,
              premium: 267.01,
              initialPayment: 286.96,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 247.06,
                dailyPremium: 6.18,
                prepaidPremium: 1111.89
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 337.23,
              premium: 357.18,
              initialPayment: 377.13,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 337.23,
                dailyPremium: 8.43,
                prepaidPremium: 3069.12
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 356.64,
              premium: 376.59,
              initialPayment: 396.54,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 356.64,
                dailyPremium: 8.92,
                prepaidPremium: 3245.86
              }
            ]
          }
        ],
        coreBenefits: {
          coinsurance: '80',
          deductibleFamily: '15000',
          lifetimeMax: '500000',
          outOfPocketMax: '15000',
          userCoinsurance: '20',
          deductible: '5000',
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-5000-15000-500000-20',
        oldPlanId: 205
      },
      '459': {
        planId: 459,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1081.71,
              premium: 1201.41,
              initialPayment: 1221.36,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 200.24,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 240.35,
              premium: 260.3,
              initialPayment: 280.25,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 240.35,
                dailyPremium: 6.01,
                prepaidPremium: 1081.71
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 324.47,
              premium: 344.42,
              initialPayment: 364.37,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 324.47,
                dailyPremium: 8.11,
                prepaidPremium: 2953.06
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 260.06,
              premium: 280.01,
              initialPayment: 299.96,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 260.06,
                dailyPremium: 6.5,
                prepaidPremium: 1170.41
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 354.97,
              premium: 374.92,
              initialPayment: 394.87,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 354.97,
                dailyPremium: 8.88,
                prepaidPremium: 3230.65
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 375.42,
              premium: 395.37,
              initialPayment: 415.32,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 375.42,
                dailyPremium: 9.39,
                prepaidPremium: 3416.69
              }
            ]
          }
        ],
        coreBenefits: {
          userCoinsurance: '20',
          lifetimeMax: '1000000',
          coinsurance: '80',
          deductibleFamily: '15000',
          outOfPocketMax: '15000',
          deductible: '5000',
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-5000-15000-1000000-20',
        oldPlanId: 203
      },
      '460': {
        planId: 460,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 747.68,
              premium: 867.38,
              initialPayment: 887.33,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 144.56,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 166.13,
              premium: 186.08,
              initialPayment: 206.03,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 166.13,
                dailyPremium: 4.15,
                prepaidPremium: 747.68
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 224.28,
              premium: 244.23,
              initialPayment: 264.18,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 224.28,
                dailyPremium: 5.61,
                prepaidPremium: 2041.16
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 179.75,
              premium: 199.7,
              initialPayment: 219.65,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 179.75,
                dailyPremium: 4.49,
                prepaidPremium: 808.99
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 245.36,
              premium: 265.31,
              initialPayment: 285.26,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 245.36,
                dailyPremium: 6.13,
                prepaidPremium: 2233.03
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 259.49,
              premium: 279.44,
              initialPayment: 299.39,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 259.49,
                dailyPremium: 6.49,
                prepaidPremium: 2361.62
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          userCoinsurance: '30',
          deductibleFamily: '15000',
          lifetimeMax: '100000',
          outOfPocketMax: '15000',
          coinsurance: '70',
          deductible: '5000',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-5000-15000-100000-30',
        oldPlanId: 201
      },
      '461': {
        planId: 461,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 872.29,
              premium: 991.99,
              initialPayment: 1011.94,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 165.33,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 193.82,
              premium: 213.77,
              initialPayment: 233.72,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 193.82,
                dailyPremium: 4.85,
                prepaidPremium: 872.29
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 261.66,
              premium: 281.61,
              initialPayment: 301.56,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 261.66,
                dailyPremium: 6.54,
                prepaidPremium: 2381.35
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 209.71,
              premium: 229.66,
              initialPayment: 249.61,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 209.71,
                dailyPremium: 5.24,
                prepaidPremium: 943.82
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 286.25,
              premium: 306.2,
              initialPayment: 326.15,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 286.25,
                dailyPremium: 7.16,
                prepaidPremium: 2605.2
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 302.74,
              premium: 322.69,
              initialPayment: 342.64,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 302.74,
                dailyPremium: 7.57,
                prepaidPremium: 2755.22
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          deductible: '5000',
          coinsurance: '70',
          lifetimeMax: '250000',
          outOfPocketMax: '15000',
          userCoinsurance: '30',
          deductibleFamily: '15000',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-5000-15000-250000-30',
        oldPlanId: null
      },
      '462': {
        planId: 462,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 986.52,
              premium: 1106.22,
              initialPayment: 1126.17,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 184.37,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 219.2,
              premium: 239.15,
              initialPayment: 259.1,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 219.2,
                dailyPremium: 5.48,
                prepaidPremium: 986.52
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 295.92,
              premium: 315.87,
              initialPayment: 335.82,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 295.92,
                dailyPremium: 7.4,
                prepaidPremium: 2693.19
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 237.17,
              premium: 257.12,
              initialPayment: 277.07,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 237.17,
                dailyPremium: 5.93,
                prepaidPremium: 1067.41
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 323.74,
              premium: 343.69,
              initialPayment: 363.64,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 323.74,
                dailyPremium: 8.09,
                prepaidPremium: 2946.35
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 342.38,
              premium: 362.33,
              initialPayment: 382.28,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 342.38,
                dailyPremium: 8.56,
                prepaidPremium: 3116.02
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          outOfPocketMax: '15000',
          lifetimeMax: '500000',
          deductibleFamily: '15000',
          coinsurance: '70',
          deductible: '5000',
          userCoinsurance: '30',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-5000-15000-500000-30',
        oldPlanId: 204
      },
      '463': {
        planId: 463,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1038.44,
              premium: 1158.14,
              initialPayment: 1178.09,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 193.02,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 230.74,
              premium: 250.69,
              initialPayment: 270.64,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 230.74,
                dailyPremium: 5.77,
                prepaidPremium: 1038.44
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 311.49,
              premium: 331.44,
              initialPayment: 351.39,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 311.49,
                dailyPremium: 7.79,
                prepaidPremium: 2834.94
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 249.66,
              premium: 269.61,
              initialPayment: 289.56,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 249.66,
                dailyPremium: 6.24,
                prepaidPremium: 1123.59
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 340.77,
              premium: 360.72,
              initialPayment: 380.67,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 340.77,
                dailyPremium: 8.52,
                prepaidPremium: 3101.42
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 360.4,
              premium: 380.35,
              initialPayment: 400.3,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 360.4,
                dailyPremium: 9.01,
                prepaidPremium: 3280.03
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          outOfPocketMax: '15000',
          deductible: '5000',
          userCoinsurance: '30',
          coinsurance: '70',
          deductibleFamily: '15000',
          lifetimeMax: '1000000',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-5000-15000-1000000-30',
        oldPlanId: 256
      },
      '464': {
        planId: 464,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 700.95,
              premium: 820.65,
              initialPayment: 840.6,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 136.78,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 155.75,
              premium: 175.7,
              initialPayment: 195.65,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 155.75,
                dailyPremium: 3.89,
                prepaidPremium: 700.95
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 210.26,
              premium: 230.21,
              initialPayment: 250.16,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 210.26,
                dailyPremium: 5.26,
                prepaidPremium: 1913.58
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 168.52,
              premium: 188.47,
              initialPayment: 208.42,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 168.52,
                dailyPremium: 4.21,
                prepaidPremium: 758.42
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 230.02,
              premium: 249.97,
              initialPayment: 269.92,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 230.02,
                dailyPremium: 5.75,
                prepaidPremium: 2093.46
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 243.27,
              premium: 263.22,
              initialPayment: 283.17,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 243.27,
                dailyPremium: 6.08,
                prepaidPremium: 2214.02
              }
            ]
          }
        ],
        coreBenefits: {
          deductible: '7500',
          deductibleFamily: '22500',
          userCoinsurance: '20',
          outOfPocketMax: '17500',
          coinsurance: '80',
          lifetimeMax: '100000',
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-7500-17500-100000-20',
        oldPlanId: null
      },
      '465': {
        planId: 465,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 817.77,
              premium: 937.47,
              initialPayment: 957.42,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 156.24,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 181.71,
              premium: 201.66,
              initialPayment: 221.61,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 181.71,
                dailyPremium: 4.54,
                prepaidPremium: 817.77
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 245.3,
              premium: 265.25,
              initialPayment: 285.2,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 245.3,
                dailyPremium: 6.13,
                prepaidPremium: 2232.52
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 196.6,
              premium: 216.55,
              initialPayment: 236.5,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 196.6,
                dailyPremium: 4.92,
                prepaidPremium: 884.83
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 268.36,
              premium: 288.31,
              initialPayment: 308.26,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 268.36,
                dailyPremium: 6.71,
                prepaidPremium: 2442.37
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 283.81,
              premium: 303.76,
              initialPayment: 323.71,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 283.81,
                dailyPremium: 7.1,
                prepaidPremium: 2583.02
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          lifetimeMax: '250000',
          outOfPocketMax: '17500',
          deductibleFamily: '22500',
          coinsurance: '80',
          userCoinsurance: '20',
          deductible: '7500',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-7500-17500-250000-20',
        oldPlanId: null
      },
      '466': {
        planId: 466,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 924.86,
              premium: 1044.56,
              initialPayment: 1064.51,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 174.09,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 205.5,
              premium: 225.45,
              initialPayment: 245.4,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 205.5,
                dailyPremium: 5.14,
                prepaidPremium: 924.86
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 277.42,
              premium: 297.37,
              initialPayment: 317.32,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 277.42,
                dailyPremium: 6.94,
                prepaidPremium: 2524.87
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 222.35,
              premium: 242.3,
              initialPayment: 262.25,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 222.35,
                dailyPremium: 5.56,
                prepaidPremium: 1000.7
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 303.5,
              premium: 323.45,
              initialPayment: 343.4,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 303.5,
                dailyPremium: 7.59,
                prepaidPremium: 2762.21
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 320.98,
              premium: 340.93,
              initialPayment: 360.88,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 320.98,
                dailyPremium: 8.03,
                prepaidPremium: 2921.27
              }
            ]
          }
        ],
        coreBenefits: {
          userCoinsurance: '20',
          outOfPocketMax: '17500',
          lifetimeMax: '500000',
          deductibleFamily: '22500',
          deductible: '7500',
          coinsurance: '80',
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-7500-17500-500000-20',
        oldPlanId: null
      },
      '467': {
        planId: 467,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 973.54,
              premium: 1093.24,
              initialPayment: 1113.19,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 182.21,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 216.32,
              premium: 236.27,
              initialPayment: 256.22,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 216.32,
                dailyPremium: 5.41,
                prepaidPremium: 973.54
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 292.03,
              premium: 311.98,
              initialPayment: 331.93,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 292.03,
                dailyPremium: 7.3,
                prepaidPremium: 2657.76
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 234.05,
              premium: 254,
              initialPayment: 273.95,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 234.05,
                dailyPremium: 5.85,
                prepaidPremium: 1053.37
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 319.48,
              premium: 339.43,
              initialPayment: 359.38,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 319.48,
                dailyPremium: 7.99,
                prepaidPremium: 2907.59
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 337.87,
              premium: 357.82,
              initialPayment: 377.77,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 337.87,
                dailyPremium: 8.45,
                prepaidPremium: 3075.02
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          lifetimeMax: '1000000',
          outOfPocketMax: '17500',
          deductible: '7500',
          deductibleFamily: '22500',
          coinsurance: '80',
          userCoinsurance: '20',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-7500-17500-1000000-20',
        oldPlanId: null
      },
      '468': {
        planId: 468,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 672.91,
              premium: 792.61,
              initialPayment: 812.56,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 132.1,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 149.52,
              premium: 169.47,
              initialPayment: 189.42,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 149.52,
                dailyPremium: 3.74,
                prepaidPremium: 672.91
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 201.85,
              premium: 221.8,
              initialPayment: 241.75,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 201.85,
                dailyPremium: 5.05,
                prepaidPremium: 1837.04
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 161.78,
              premium: 181.73,
              initialPayment: 201.68,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 161.78,
                dailyPremium: 4.04,
                prepaidPremium: 728.09
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 220.82,
              premium: 240.77,
              initialPayment: 260.72,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 220.82,
                dailyPremium: 5.52,
                prepaidPremium: 2009.72
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 233.54,
              premium: 253.49,
              initialPayment: 273.44,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 233.54,
                dailyPremium: 5.84,
                prepaidPremium: 2125.46
              }
            ]
          }
        ],
        coreBenefits: {
          deductibleFamily: '22500',
          lifetimeMax: '100000',
          coinsurance: '70',
          deductible: '7500',
          userCoinsurance: '30',
          outOfPocketMax: '17500',
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-7500-17500-100000-30',
        oldPlanId: 206
      },
      '469': {
        planId: 469,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 785.06,
              premium: 904.76,
              initialPayment: 924.71,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 150.79,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 174.44,
              premium: 194.39,
              initialPayment: 214.34,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 174.44,
                dailyPremium: 4.36,
                prepaidPremium: 785.06
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 235.49,
              premium: 255.44,
              initialPayment: 275.39,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 235.49,
                dailyPremium: 5.89,
                prepaidPremium: 2143.21
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 188.74,
              premium: 208.69,
              initialPayment: 228.64,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 188.74,
                dailyPremium: 4.72,
                prepaidPremium: 849.44
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 257.63,
              premium: 277.58,
              initialPayment: 297.53,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 257.63,
                dailyPremium: 6.44,
                prepaidPremium: 2344.68
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 272.46,
              premium: 292.41,
              initialPayment: 312.36,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 272.46,
                dailyPremium: 6.81,
                prepaidPremium: 2479.7
              }
            ]
          }
        ],
        coreBenefits: {
          coinsurance: '70',
          lifetimeMax: '250000',
          deductibleFamily: '22500',
          deductible: '7500',
          userCoinsurance: '30',
          outOfPocketMax: '17500',
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-7500-17500-250000-30',
        oldPlanId: null
      },
      '470': {
        planId: 470,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 887.87,
              premium: 1007.57,
              initialPayment: 1027.52,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 167.93,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 197.28,
              premium: 217.23,
              initialPayment: 237.18,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 197.28,
                dailyPremium: 4.93,
                prepaidPremium: 887.87
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 266.33,
              premium: 286.28,
              initialPayment: 306.23,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 266.33,
                dailyPremium: 6.66,
                prepaidPremium: 2423.87
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 213.46,
              premium: 233.41,
              initialPayment: 253.36,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 213.46,
                dailyPremium: 5.34,
                prepaidPremium: 960.67
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 291.36,
              premium: 311.31,
              initialPayment: 331.26,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 291.36,
                dailyPremium: 7.28,
                prepaidPremium: 2651.72
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 308.14,
              premium: 328.09,
              initialPayment: 348.04,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 308.14,
                dailyPremium: 7.7,
                prepaidPremium: 2804.42
              }
            ]
          }
        ],
        coreBenefits: {
          coinsurance: '70',
          userCoinsurance: '30',
          outOfPocketMax: '17500',
          deductibleFamily: '22500',
          lifetimeMax: '500000',
          deductible: '7500',
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-7500-17500-500000-30',
        oldPlanId: 207
      },
      '471': {
        planId: 471,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 934.6,
              premium: 1054.3,
              initialPayment: 1074.25,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 175.72,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 207.66,
              premium: 227.61,
              initialPayment: 247.56,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 207.66,
                dailyPremium: 5.19,
                prepaidPremium: 934.6
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 280.34,
              premium: 300.29,
              initialPayment: 320.24,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 280.34,
                dailyPremium: 7.01,
                prepaidPremium: 2551.45
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 224.69,
              premium: 244.64,
              initialPayment: 264.59,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 224.69,
                dailyPremium: 5.62,
                prepaidPremium: 1011.23
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 306.7,
              premium: 326.65,
              initialPayment: 346.6,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 306.7,
                dailyPremium: 7.67,
                prepaidPremium: 2791.28
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 324.36,
              premium: 344.31,
              initialPayment: 364.26,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 324.36,
                dailyPremium: 8.11,
                prepaidPremium: 2952.02
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          outOfPocketMax: '17500',
          lifetimeMax: '1000000',
          deductibleFamily: '22500',
          coinsurance: '70',
          userCoinsurance: '30',
          deductible: '7500',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-7500-17500-1000000-30',
        oldPlanId: 258
      },
      '472': {
        planId: 472,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 623.06,
              premium: 742.76,
              initialPayment: 762.71,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 123.79,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 138.44,
              premium: 158.39,
              initialPayment: 178.34,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 138.44,
                dailyPremium: 3.46,
                prepaidPremium: 623.06
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 186.9,
              premium: 206.85,
              initialPayment: 226.8,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 186.9,
                dailyPremium: 4.67,
                prepaidPremium: 1700.96
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 149.79,
              premium: 169.74,
              initialPayment: 189.69,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 149.79,
                dailyPremium: 3.75,
                prepaidPremium: 674.16
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 204.46,
              premium: 224.41,
              initialPayment: 244.36,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 204.46,
                dailyPremium: 5.11,
                prepaidPremium: 1860.85
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 216.24,
              premium: 236.19,
              initialPayment: 256.14,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 216.24,
                dailyPremium: 5.41,
                prepaidPremium: 1968.02
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          outOfPocketMax: '20000',
          coinsurance: '80',
          deductibleFamily: '30000',
          userCoinsurance: '20',
          deductible: '10000',
          lifetimeMax: '100000',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-10000-20000-100000-20',
        oldPlanId: null
      },
      '473': {
        planId: 473,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 726.91,
              premium: 846.61,
              initialPayment: 866.56,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 141.1,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 161.52,
              premium: 181.47,
              initialPayment: 201.42,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 161.52,
                dailyPremium: 4.04,
                prepaidPremium: 726.91
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 218.05,
              premium: 238,
              initialPayment: 257.95,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 218.05,
                dailyPremium: 5.45,
                prepaidPremium: 1984.46
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 174.76,
              premium: 194.71,
              initialPayment: 214.66,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 174.76,
                dailyPremium: 4.37,
                prepaidPremium: 786.51
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 238.54,
              premium: 258.49,
              initialPayment: 278.44,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 238.54,
                dailyPremium: 5.96,
                prepaidPremium: 2171
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 252.28,
              premium: 272.23,
              initialPayment: 292.18,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 252.28,
                dailyPremium: 6.31,
                prepaidPremium: 2296.02
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          deductible: '10000',
          lifetimeMax: '250000',
          deductibleFamily: '30000',
          userCoinsurance: '20',
          outOfPocketMax: '20000',
          coinsurance: '80',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-10000-20000-250000-20',
        oldPlanId: null
      },
      '474': {
        planId: 474,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 822.1,
              premium: 941.8,
              initialPayment: 961.75,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 156.97,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 182.67,
              premium: 202.62,
              initialPayment: 222.57,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 182.67,
                dailyPremium: 4.57,
                prepaidPremium: 822.1
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 246.6,
              premium: 266.55,
              initialPayment: 286.5,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 246.6,
                dailyPremium: 6.17,
                prepaidPremium: 2244.33
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 197.65,
              premium: 217.6,
              initialPayment: 237.55,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 197.65,
                dailyPremium: 4.94,
                prepaidPremium: 889.51
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 269.78,
              premium: 289.73,
              initialPayment: 309.68,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 269.78,
                dailyPremium: 6.75,
                prepaidPremium: 2455.29
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 285.32,
              premium: 305.27,
              initialPayment: 325.22,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 285.32,
                dailyPremium: 7.13,
                prepaidPremium: 2596.69
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          outOfPocketMax: '20000',
          deductibleFamily: '30000',
          userCoinsurance: '20',
          deductible: '10000',
          lifetimeMax: '500000',
          coinsurance: '80',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-10000-20000-500000-20',
        oldPlanId: 249
      },
      '475': {
        planId: 475,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 865.37,
              premium: 985.07,
              initialPayment: 1005.02,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 164.18,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 192.28,
              premium: 212.23,
              initialPayment: 232.18,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 192.28,
                dailyPremium: 4.81,
                prepaidPremium: 865.37
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 259.58,
              premium: 279.53,
              initialPayment: 299.48,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 259.58,
                dailyPremium: 6.49,
                prepaidPremium: 2362.45
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 208.05,
              premium: 228,
              initialPayment: 247.95,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 208.05,
                dailyPremium: 5.2,
                prepaidPremium: 936.33
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 283.98,
              premium: 303.93,
              initialPayment: 323.88,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 283.98,
                dailyPremium: 7.1,
                prepaidPremium: 2584.52
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 300.33,
              premium: 320.28,
              initialPayment: 340.23,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 300.33,
                dailyPremium: 7.51,
                prepaidPremium: 2733.36
              }
            ]
          }
        ],
        coreBenefits: {
          outOfPocketMax: '20000',
          deductibleFamily: '30000',
          coinsurance: '80',
          deductible: '10000',
          userCoinsurance: '20',
          lifetimeMax: '1000000',
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-10000-20000-1000000-20',
        oldPlanId: 195
      },
      '476': {
        planId: 476,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 598.14,
              premium: 717.84,
              initialPayment: 737.79,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 119.64,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 132.9,
              premium: 152.85,
              initialPayment: 172.8,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 132.9,
                dailyPremium: 3.32,
                prepaidPremium: 598.14
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 179.42,
              premium: 199.37,
              initialPayment: 219.32,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 179.42,
                dailyPremium: 4.49,
                prepaidPremium: 1632.93
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 143.8,
              premium: 163.75,
              initialPayment: 183.7,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 143.8,
                dailyPremium: 3.6,
                prepaidPremium: 647.19
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 196.29,
              premium: 216.24,
              initialPayment: 236.19,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 196.29,
                dailyPremium: 4.91,
                prepaidPremium: 1786.42
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 207.59,
              premium: 227.54,
              initialPayment: 247.49,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 207.59,
                dailyPremium: 5.19,
                prepaidPremium: 1889.29
              }
            ]
          }
        ],
        coreBenefits: {
          lifetimeMax: '100000',
          outOfPocketMax: '20000',
          userCoinsurance: '30',
          coinsurance: '70',
          deductibleFamily: '30000',
          deductible: '10000',
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-10000-20000-100000-30',
        oldPlanId: 194
      },
      '477': {
        planId: 477,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 697.83,
              premium: 817.53,
              initialPayment: 837.48,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 136.26,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 155.05,
              premium: 175,
              initialPayment: 194.95,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 155.05,
                dailyPremium: 3.88,
                prepaidPremium: 697.83
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 209.32,
              premium: 229.27,
              initialPayment: 249.22,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 209.32,
                dailyPremium: 5.23,
                prepaidPremium: 1905.08
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 167.77,
              premium: 187.72,
              initialPayment: 207.67,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 167.77,
                dailyPremium: 4.19,
                prepaidPremium: 755.05
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 229,
              premium: 248.95,
              initialPayment: 268.9,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 229,
                dailyPremium: 5.73,
                prepaidPremium: 2084.16
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 242.19,
              premium: 262.14,
              initialPayment: 282.09,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 242.19,
                dailyPremium: 6.06,
                prepaidPremium: 2204.18
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          lifetimeMax: '250000',
          userCoinsurance: '30',
          deductible: '10000',
          coinsurance: '70',
          deductibleFamily: '30000',
          outOfPocketMax: '20000',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-10000-20000-250000-30',
        oldPlanId: null
      },
      '478': {
        planId: 478,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 789.21,
              premium: 908.91,
              initialPayment: 928.86,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 151.48,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 175.36,
              premium: 195.31,
              initialPayment: 215.26,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 175.36,
                dailyPremium: 4.38,
                prepaidPremium: 789.21
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 236.74,
              premium: 256.69,
              initialPayment: 276.64,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 236.74,
                dailyPremium: 5.92,
                prepaidPremium: 2154.55
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 189.74,
              premium: 209.69,
              initialPayment: 229.64,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 189.74,
                dailyPremium: 4.74,
                prepaidPremium: 853.93
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 258.99,
              premium: 278.94,
              initialPayment: 298.89,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 258.99,
                dailyPremium: 6.48,
                prepaidPremium: 2357.08
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 273.9,
              premium: 293.85,
              initialPayment: 313.8,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 273.9,
                dailyPremium: 6.85,
                prepaidPremium: 2492.82
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          lifetimeMax: '500000',
          deductibleFamily: '30000',
          outOfPocketMax: '20000',
          coinsurance: '70',
          deductible: '10000',
          userCoinsurance: '30',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-10000-20000-500000-30',
        oldPlanId: 248
      },
      '479': {
        planId: 479,
        productId: 6,
        brochureId: 5,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Economy',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 830.75,
              premium: 950.45,
              initialPayment: 970.4,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 158.41,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 184.59,
              premium: 204.54,
              initialPayment: 224.49,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 184.59,
                dailyPremium: 4.62,
                prepaidPremium: 830.75
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 249.2,
              premium: 269.15,
              initialPayment: 289.1,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 249.2,
                dailyPremium: 6.23,
                prepaidPremium: 2267.95
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 199.73,
              premium: 219.68,
              initialPayment: 239.63,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 199.73,
                dailyPremium: 4.99,
                prepaidPremium: 898.87
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 272.62,
              premium: 292.57,
              initialPayment: 312.52,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 272.62,
                dailyPremium: 6.82,
                prepaidPremium: 2481.14
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 288.32,
              premium: 308.27,
              initialPayment: 328.22,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 288.32,
                dailyPremium: 7.21,
                prepaidPremium: 2624.02
              }
            ]
          }
        ],
        coreBenefits: {
          userCoinsurance: '30',
          outOfPocketMax: '20000',
          deductibleFamily: '30000',
          lifetimeMax: '1000000',
          coinsurance: '70',
          deductible: '10000',
          officeVisitCopayFrequencyLimitation: '0',
          inpatientCopay: '750',
          rxSchedule: '01',
          networkProvider: 'any-provider',
          officeVisitCopayPrimaryCare: '0',
          patientAdvocacyServices: 'true',
          network: 'Non-PPO',
          outpatientFacilityCopay: '500',
          emergencyRoomCopay: '450',
          officeVisitCopay: '$0',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-ECO-10000-20000-1000000-30',
        oldPlanId: null
      },
      '488': {
        planId: 488,
        productId: 13,
        brochureId: 3,
        carrierId: 3,
        jsonId: 8,
        planName: 'Pivot Health Standard',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 2203.86,
              premium: 2323.56,
              initialPayment: 2343.51,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 387.26,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 489.66,
              premium: 509.61,
              initialPayment: 529.56,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 489.66,
                dailyPremium: 12.24,
                prepaidPremium: 2203.86
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 661.04,
              premium: 680.99,
              initialPayment: 700.94,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 661.04,
                dailyPremium: 16.53,
                prepaidPremium: 6016.53
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 529.81,
              premium: 549.76,
              initialPayment: 569.71,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 529.81,
                dailyPremium: 13.25,
                prepaidPremium: 2384.57
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 723.18,
              premium: 743.13,
              initialPayment: 763.08,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 723.18,
                dailyPremium: 18.08,
                prepaidPremium: 6582.08
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 764.83,
              premium: 784.78,
              initialPayment: 804.73,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 764.83,
                dailyPremium: 19.12,
                prepaidPremium: 6961.13
              }
            ]
          }
        ],
        coreBenefits: {
          outOfPocketMax: '7000',
          lifetimeMax: '500000',
          deductible: '2000',
          deductibleFamily: '6000',
          officeVisitCopayFrequencyLimitation: '0',
          userCoinsurance: '20',
          network: 'Non-PPO',
          officeVisitCopay: '$0',
          officeVisitCopayPrimaryCare: '0',
          emergencyRoomCopay: '350',
          inpatientCopay: '500',
          outpatientFacilityCopay: '0',
          networkProvider: 'any-provider',
          rxSchedule: '05',
          patientAdvocacyServices: 'true',
          coinsurance: '80',
          rxScheduleDescription:
            '$10/$30/$75 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'CLIC-STM-STD-2000-7000-500000-20',
        oldPlanId: 209
      },
      '489': {
        planId: 489,
        productId: 13,
        brochureId: 3,
        carrierId: 3,
        jsonId: 8,
        planName: 'Pivot Health Standard',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1992.18,
              premium: 2111.88,
              initialPayment: 2131.83,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 351.98,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 442.63,
              premium: 462.58,
              initialPayment: 482.53,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 442.63,
                dailyPremium: 11.07,
                prepaidPremium: 1992.18
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 597.55,
              premium: 617.5,
              initialPayment: 637.45,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 597.55,
                dailyPremium: 14.94,
                prepaidPremium: 5438.66
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 478.92,
              premium: 498.87,
              initialPayment: 518.82,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 478.92,
                dailyPremium: 11.98,
                prepaidPremium: 2155.54
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 653.72,
              premium: 673.67,
              initialPayment: 693.62,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 653.72,
                dailyPremium: 16.35,
                prepaidPremium: 5949.89
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 691.36,
              premium: 711.31,
              initialPayment: 731.26,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 691.36,
                dailyPremium: 17.29,
                prepaidPremium: 6292.53
              }
            ]
          }
        ],
        coreBenefits: {
          outOfPocketMax: '7000',
          deductibleFamily: '6000',
          lifetimeMax: '250000',
          deductible: '2000',
          officeVisitCopayFrequencyLimitation: '0',
          userCoinsurance: '20',
          network: 'Non-PPO',
          officeVisitCopay: '$0',
          officeVisitCopayPrimaryCare: '0',
          emergencyRoomCopay: '350',
          inpatientCopay: '500',
          outpatientFacilityCopay: '0',
          networkProvider: 'any-provider',
          rxSchedule: '05',
          patientAdvocacyServices: 'true',
          coinsurance: '80',
          rxScheduleDescription:
            '$10/$30/$75 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'CLIC-STM-STD-2000-7000-250000-20',
        oldPlanId: 208
      },
      '491': {
        planId: 491,
        productId: 13,
        brochureId: 3,
        carrierId: 3,
        jsonId: 8,
        planName: 'Pivot Health Standard',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1850.03,
              premium: 1969.73,
              initialPayment: 1989.68,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 328.29,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 411.04,
              premium: 430.99,
              initialPayment: 450.94,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 411.04,
                dailyPremium: 10.28,
                prepaidPremium: 1850.03
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 554.91,
              premium: 574.86,
              initialPayment: 594.81,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 554.91,
                dailyPremium: 13.88,
                prepaidPremium: 5050.59
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 444.75,
              premium: 464.7,
              initialPayment: 484.65,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 444.75,
                dailyPremium: 11.12,
                prepaidPremium: 2001.74
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 607.07,
              premium: 627.02,
              initialPayment: 646.97,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 607.07,
                dailyPremium: 15.18,
                prepaidPremium: 5525.34
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 642.03,
              premium: 661.98,
              initialPayment: 681.93,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 642.03,
                dailyPremium: 16.05,
                prepaidPremium: 5843.53
              }
            ]
          }
        ],
        coreBenefits: {
          lifetimeMax: '500000',
          deductibleFamily: '9000',
          deductible: '3000',
          outOfPocketMax: '8000',
          officeVisitCopayFrequencyLimitation: '0',
          userCoinsurance: '20',
          network: 'Non-PPO',
          officeVisitCopay: '$0',
          officeVisitCopayPrimaryCare: '0',
          emergencyRoomCopay: '350',
          inpatientCopay: '500',
          outpatientFacilityCopay: '0',
          networkProvider: 'any-provider',
          rxSchedule: '05',
          patientAdvocacyServices: 'true',
          coinsurance: '80',
          rxScheduleDescription:
            '$10/$30/$75 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'CLIC-STM-STD-3000-8000-500000-20',
        oldPlanId: 211
      },
      '492': {
        planId: 492,
        productId: 13,
        brochureId: 3,
        carrierId: 3,
        jsonId: 8,
        planName: 'Pivot Health Standard',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1679.33,
              premium: 1799.03,
              initialPayment: 1818.98,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 299.84,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 373.11,
              premium: 393.06,
              initialPayment: 413.01,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 373.11,
                dailyPremium: 9.33,
                prepaidPremium: 1679.33
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 503.7,
              premium: 523.65,
              initialPayment: 543.6,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 503.7,
                dailyPremium: 12.59,
                prepaidPremium: 4584.56
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 403.71,
              premium: 423.66,
              initialPayment: 443.61,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 403.71,
                dailyPremium: 10.09,
                prepaidPremium: 1817.03
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 551.05,
              premium: 571,
              initialPayment: 590.95,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 551.05,
                dailyPremium: 13.78,
                prepaidPremium: 5015.51
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 582.78,
              premium: 602.73,
              initialPayment: 622.68,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 582.78,
                dailyPremium: 14.57,
                prepaidPremium: 5304.34
              }
            ]
          }
        ],
        coreBenefits: {
          deductibleFamily: '9000',
          deductible: '3000',
          outOfPocketMax: '8000',
          lifetimeMax: '250000',
          officeVisitCopayFrequencyLimitation: '0',
          userCoinsurance: '20',
          network: 'Non-PPO',
          officeVisitCopay: '$0',
          officeVisitCopayPrimaryCare: '0',
          emergencyRoomCopay: '350',
          inpatientCopay: '500',
          outpatientFacilityCopay: '0',
          networkProvider: 'any-provider',
          rxSchedule: '05',
          patientAdvocacyServices: 'true',
          coinsurance: '80',
          rxScheduleDescription:
            '$10/$30/$75 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'CLIC-STM-STD-3000-8000-250000-20',
        oldPlanId: 210
      },
      '494': {
        planId: 494,
        productId: 13,
        brochureId: 3,
        carrierId: 3,
        jsonId: 8,
        planName: 'Pivot Health Standard',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1555.18,
              premium: 1674.88,
              initialPayment: 1694.83,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 279.15,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 345.53,
              premium: 365.48,
              initialPayment: 385.43,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 345.53,
                dailyPremium: 8.64,
                prepaidPremium: 1555.18
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 466.46,
              premium: 486.41,
              initialPayment: 506.36,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 466.46,
                dailyPremium: 11.66,
                prepaidPremium: 4245.64
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 373.86,
              premium: 393.81,
              initialPayment: 413.76,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 373.86,
                dailyPremium: 9.35,
                prepaidPremium: 1682.7
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 510.31,
              premium: 530.26,
              initialPayment: 550.21,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 510.31,
                dailyPremium: 12.76,
                prepaidPremium: 4644.73
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 539.7,
              premium: 559.65,
              initialPayment: 579.6,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 539.7,
                dailyPremium: 13.5,
                prepaidPremium: 4912.2
              }
            ]
          }
        ],
        coreBenefits: {
          officeVisitCopayFrequencyLimitation: '0',
          userCoinsurance: '20',
          network: 'Non-PPO',
          officeVisitCopay: '$0',
          officeVisitCopayPrimaryCare: '0',
          emergencyRoomCopay: '350',
          inpatientCopay: '500',
          outpatientFacilityCopay: '0',
          networkProvider: 'any-provider',
          rxSchedule: '05',
          patientAdvocacyServices: 'true',
          coinsurance: '80',
          lifetimeMax: '500000',
          deductibleFamily: '15000',
          outOfPocketMax: '10000',
          deductible: '5000',
          rxScheduleDescription:
            '$10/$30/$75 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'CLIC-STM-STD-5000-10000-500000-20',
        oldPlanId: 213
      },
      '495': {
        planId: 495,
        productId: 13,
        brochureId: 3,
        carrierId: 3,
        jsonId: 8,
        planName: 'Pivot Health Standard',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1418.61,
              premium: 1538.31,
              initialPayment: 1558.26,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                }
              ],
              monthlyDiscountedRate: 256.38,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 315.18,
              premium: 335.13,
              initialPayment: 355.08,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 315.18,
                dailyPremium: 7.88,
                prepaidPremium: 1418.61
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 425.5,
              premium: 445.45,
              initialPayment: 465.4,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 425.5,
                dailyPremium: 10.64,
                prepaidPremium: 3872.82
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 341.03,
              premium: 360.98,
              initialPayment: 380.93,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 341.03,
                dailyPremium: 8.53,
                prepaidPremium: 1534.94
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 465.49,
              premium: 485.44,
              initialPayment: 505.39,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 465.49,
                dailyPremium: 11.64,
                prepaidPremium: 4236.86
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 492.3,
              premium: 512.25,
              initialPayment: 532.2,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 492.3,
                dailyPremium: 12.31,
                prepaidPremium: 4480.85
              }
            ]
          }
        ],
        coreBenefits: {
          outOfPocketMax: '10000',
          deductible: '5000',
          deductibleFamily: '15000',
          lifetimeMax: '250000',
          officeVisitCopayFrequencyLimitation: '0',
          userCoinsurance: '20',
          network: 'Non-PPO',
          officeVisitCopay: '$0',
          officeVisitCopayPrimaryCare: '0',
          emergencyRoomCopay: '350',
          inpatientCopay: '500',
          outpatientFacilityCopay: '0',
          networkProvider: 'any-provider',
          rxSchedule: '05',
          patientAdvocacyServices: 'true',
          coinsurance: '80',
          rxScheduleDescription:
            '$10/$30/$75 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'CLIC-STM-STD-5000-10000-250000-20',
        oldPlanId: 212
      },
      '497': {
        planId: 497,
        productId: 15,
        brochureId: 7,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Core 1000 PPO',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1249.14,
              premium: 1368.84,
              initialPayment: 1388.79,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 228.14,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 277.55,
              premium: 297.5,
              initialPayment: 317.45,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 277.55,
                dailyPremium: 6.94,
                prepaidPremium: 1249.14
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 374.7,
              premium: 394.65,
              initialPayment: 414.6,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 374.7,
                dailyPremium: 9.37,
                prepaidPremium: 3410.15
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 300.31,
              premium: 320.26,
              initialPayment: 340.21,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 300.31,
                dailyPremium: 7.51,
                prepaidPremium: 1351.57
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 409.92,
              premium: 429.87,
              initialPayment: 449.82,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 409.92,
                dailyPremium: 10.25,
                prepaidPremium: 3730.7
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 433.52,
              premium: 453.47,
              initialPayment: 473.42,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 433.52,
                dailyPremium: 10.84,
                prepaidPremium: 3945.54
              }
            ]
          }
        ],
        coreBenefits: {
          deductibleFamily: '3000',
          outOfPocketMax: '2000',
          deductible: '1000',
          rxSchedule: '01',
          officeVisitCopayGeneralPractitioner: '30',
          network: 'PPO',
          officeVisitCopayUrgentCare: '60',
          networkProvider: 'first-health',
          coinsurance: '80',
          patientAdvocacyServices: 'true',
          userCoinsurance: '20',
          officeVisitCopay: '$30/$60/$60',
          officeVisitCopayFrequencyLimitation: '3',
          officeVisitCopaySpecialist: '60',
          negotiatedDiscount: '1',
          lifetimeMax: '750000',
          rxScheduleDescription: 'Discount Card Only'
        },
        legacyId: 'CLIC-STM-COR-1000-2000-750000-20',
        oldPlanId: null
      },
      '498': {
        planId: 498,
        productId: 15,
        brochureId: 7,
        carrierId: 3,
        jsonId: null,
        planName: 'Pivot Health Core 2000 PPO',
        authorizeName: 'companion',
        addOnPlanIds: [10, 11, 345],
        durations: [
          {
            policyDuration: 180,
            extendedDurationsAvailable: [],
            durationId: 2,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: {
              baseRate: 1343.85,
              premium: 1463.55,
              initialPayment: 1483.5,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 12.06
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 107.64
                }
              ],
              monthlyDiscountedRate: 243.92,
              coverageDuration: 0
            },
            monthly: {
              baseRate: 298.57,
              premium: 318.52,
              initialPayment: 338.47,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 298.57,
                dailyPremium: 7.47,
                prepaidPremium: 1343.85
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [],
            durationId: 3,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 1,
            prepaid: null,
            monthly: {
              baseRate: 403.07,
              premium: 423.02,
              initialPayment: 442.97,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 403.07,
                dailyPremium: 10.08,
                prepaidPremium: 3668.7
              }
            ]
          },
          {
            policyDuration: 180,
            extendedDurationsAvailable: [180],
            durationId: 5,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 323.05,
              premium: 343,
              initialPayment: 362.95,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 323.05,
                dailyPremium: 8.08,
                prepaidPremium: 1454.04
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 6,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2,
            prepaid: null,
            monthly: {
              baseRate: 440.96,
              premium: 460.91,
              initialPayment: 480.86,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 440.96,
                dailyPremium: 11.03,
                prepaidPremium: 4013.56
              }
            ]
          },
          {
            policyDuration: 364,
            extendedDurationsAvailable: [364],
            durationId: 7,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 466.35,
              premium: 486.3,
              initialPayment: 506.25,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '04/11/1970',
                gender: 'M',
                role: 'PRIMARY',
                age: 53,
                monthlyPremium: 466.35,
                dailyPremium: 11.66,
                prepaidPremium: 4244.69
              }
            ]
          }
        ],
        coreBenefits: {
          deductible: '2000',
          rxSchedule: '05',
          deductibleFamily: '6000',
          outOfPocketMax: '3000',
          officeVisitCopayGeneralPractitioner: '30',
          network: 'PPO',
          officeVisitCopayUrgentCare: '60',
          networkProvider: 'first-health',
          coinsurance: '80',
          patientAdvocacyServices: 'true',
          userCoinsurance: '20',
          officeVisitCopay: '$30/$60/$60',
          officeVisitCopayFrequencyLimitation: '3',
          officeVisitCopaySpecialist: '60',
          negotiatedDiscount: '1',
          lifetimeMax: '750000',
          rxScheduleDescription:
            '$10/$30/$75 ($1K Benefit Max for 180 Day Plan; $2K Benefit Max for 364 Day Plan)'
        },
        legacyId: 'CLIC-STM-COR-2000-3000-750000-20',
        oldPlanId: null
      },
      '500': {
        planId: 500,
        productId: 17,
        brochureId: 1,
        carrierId: 5,
        jsonId: 1,
        planName: 'Pivot Health Epic MULTI A',
        authorizeName: 'nric',
        addOnPlanIds: [],
        multiCarrierPlan: true,
        durations: [
          {
            policyDuration: 120,
            extendedDurationsAvailable: [120],
            durationId: 20,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 401,
              premium: 420.95,
              initialPayment: 440.9,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2.0
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '01/15/1989',
                gender: 'F',
                role: 'PRIMARY',
                monthlyPremium: 401,
                dailyPremium: 0,
                prepaidPremium: 0.0
              }
            ]
          },
          {
            policyDuration: 120,
            extendedDurationsAvailable: [120],
            durationId: 20,
            durationUnit: 'DAYS',
            sequence: 2,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 401,
              premium: 420.95,
              initialPayment: 440.9,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2.0
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '01/15/1989',
                gender: 'F',
                role: 'PRIMARY',
                monthlyPremium: 401,
                dailyPremium: 0,
                prepaidPremium: 0.0
              }
            ]
          },
          {
            policyDuration: 120,
            extendedDurationsAvailable: [120],
            durationId: 20,
            durationUnit: 'DAYS',
            sequence: 3,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 401,
              premium: 420.95,
              initialPayment: 440.9,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2.0
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '01/15/1989',
                gender: 'F',
                role: 'PRIMARY',
                monthlyPremium: 401,
                dailyPremium: 0,
                prepaidPremium: 0.0
              }
            ]
          }
        ],
        coreBenefits: {
          deductible: '1000',
          outOfPocketMax: '3000',
          userCoinsurance: '20',
          lifetimeMax: '100000',
          planType: 'Epic High Deductible PPO'
        }
      },
      '501': {
        planId: 501,
        productId: 17,
        brochureId: 1,
        carrierId: 5,
        jsonId: 1,
        planName: 'Pivot Health Epic MULTI B',
        authorizeName: 'nric',
        addOnPlanIds: [],
        multiCarrierPlan: true,
        durations: [
          {
            policyDuration: 120,
            extendedDurationsAvailable: [120],
            durationId: 20,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 381.28,
              premium: 401.23,
              initialPayment: 421.18,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2.0
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '01/15/1989',
                gender: 'F',
                role: 'PRIMARY',
                monthlyPremium: 281.35,
                dailyPremium: 0,
                prepaidPremium: 0.0
              }
            ]
          },
          {
            policyDuration: 120,
            extendedDurationsAvailable: [120],
            durationId: 20,
            durationUnit: 'DAYS',
            sequence: 2,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 381.28,
              premium: 401.23,
              initialPayment: 421.18,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2.0
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '01/15/1989',
                gender: 'F',
                role: 'PRIMARY',
                monthlyPremium: 281.35,
                dailyPremium: 0,
                prepaidPremium: 0.0
              }
            ]
          },
          {
            policyDuration: 120,
            extendedDurationsAvailable: [120],
            durationId: 20,
            durationUnit: 'DAYS',
            sequence: 3,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 381.28,
              premium: 401.23,
              initialPayment: 421.18,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2.0
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '01/15/1989',
                gender: 'F',
                role: 'PRIMARY',
                monthlyPremium: 281.35,
                dailyPremium: 0,
                prepaidPremium: 0.0
              }
            ]
          }
        ],
        coreBenefits: {
          deductible: '2000',
          outOfPocketMax: '1000',
          userCoinsurance: '30',
          lifetimeMax: '250000',
          planType: 'Epic High Deductible PPO'
        }
      },
      '600': {
        planId: 600,
        productId: 13,
        brochureId: 1,
        carrierId: 3,
        jsonId: 1,
        planName: 'Pivot Health CLIC MULTI A',
        authorizeName: 'nric',
        addOnPlanIds: [],
        multiCarrierPlan: true,
        durations: [
          {
            policyDuration: 120,
            extendedDurationsAvailable: [120],
            durationId: 20,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 281.35,
              premium: 301.3,
              initialPayment: 321.25,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2.0
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '01/15/1989',
                gender: 'F',
                role: 'PRIMARY',
                monthlyPremium: 281.35,
                dailyPremium: 0,
                prepaidPremium: 0.0
              }
            ]
          },
          {
            policyDuration: 120,
            extendedDurationsAvailable: [120],
            durationId: 20,
            durationUnit: 'DAYS',
            sequence: 2,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 281.35,
              premium: 301.3,
              initialPayment: 321.25,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2.0
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '01/15/1989',
                gender: 'F',
                role: 'PRIMARY',
                monthlyPremium: 281.35,
                dailyPremium: 0,
                prepaidPremium: 0.0
              }
            ]
          },
          {
            policyDuration: 120,
            extendedDurationsAvailable: [120],
            durationId: 20,
            durationUnit: 'DAYS',
            sequence: 3,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 281.35,
              premium: 301.3,
              initialPayment: 321.25,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2.0
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '01/15/1989',
                gender: 'F',
                role: 'PRIMARY',
                monthlyPremium: 281.35,
                dailyPremium: 0,
                prepaidPremium: 0.0
              }
            ]
          }
        ],
        coreBenefits: {
          deductible: '1000',
          outOfPocketMax: '3000',
          userCoinsurance: '20',
          lifetimeMax: '100000',
          planType: 'Epic High Deductible PPO'
        }
      },
      '601': {
        planId: 601,
        productId: 13,
        brochureId: 1,
        carrierId: 3,
        jsonId: 1,
        planName: 'Pivot Health CLIC MULTI B',
        authorizeName: 'nric',
        addOnPlanIds: [],
        multiCarrierPlan: true,
        durations: [
          {
            policyDuration: 120,
            extendedDurationsAvailable: [120],
            durationId: 20,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 381.28,
              premium: 401.23,
              initialPayment: 421.18,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2.0
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '01/15/1989',
                gender: 'F',
                role: 'PRIMARY',
                monthlyPremium: 281.35,
                dailyPremium: 0,
                prepaidPremium: 0.0
              }
            ]
          },
          {
            policyDuration: 120,
            extendedDurationsAvailable: [120],
            durationId: 20,
            durationUnit: 'DAYS',
            sequence: 2,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 281.35,
              premium: 301.3,
              initialPayment: 321.25,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2.0
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '01/15/1989',
                gender: 'F',
                role: 'PRIMARY',
                monthlyPremium: 281.35,
                dailyPremium: 0,
                prepaidPremium: 0.0
              }
            ]
          },
          {
            policyDuration: 120,
            extendedDurationsAvailable: [120],
            durationId: 20,
            durationUnit: 'DAYS',
            sequence: 3,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 381.28,
              premium: 401.23,
              initialPayment: 421.18,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2.0
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '01/15/1989',
                gender: 'F',
                role: 'PRIMARY',
                monthlyPremium: 281.35,
                dailyPremium: 0,
                prepaidPremium: 0.0
              }
            ]
          }
        ],
        coreBenefits: {
          deductible: '2000',
          outOfPocketMax: '1000',
          userCoinsurance: '30',
          lifetimeMax: '250000',
          planType: 'Epic High Deductible PPO'
        }
      },
      '700': {
        planId: 700,
        productId: 24,
        brochureId: 1,
        carrierId: 5,
        jsonId: 1,
        planName: 'Pivot Health NEW CARRIER MULTI A',
        authorizeName: 'nric',
        addOnPlanIds: [],
        multiCarrierPlan: true,
        durations: [
          {
            policyDuration: 120,
            extendedDurationsAvailable: [120],
            durationId: 20,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 281.35,
              premium: 301.3,
              initialPayment: 321.25,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2.0
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '01/15/1989',
                gender: 'F',
                role: 'PRIMARY',
                monthlyPremium: 281.35,
                dailyPremium: 0,
                prepaidPremium: 0.0
              }
            ]
          },
          {
            policyDuration: 120,
            extendedDurationsAvailable: [120],
            durationId: 20,
            durationUnit: 'DAYS',
            sequence: 2,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 281.35,
              premium: 301.3,
              initialPayment: 321.25,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2.0
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '01/15/1989',
                gender: 'F',
                role: 'PRIMARY',
                monthlyPremium: 281.35,
                dailyPremium: 0,
                prepaidPremium: 0.0
              }
            ]
          },
          {
            policyDuration: 120,
            extendedDurationsAvailable: [120],
            durationId: 20,
            durationUnit: 'DAYS',
            sequence: 3,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 281.35,
              premium: 301.3,
              initialPayment: 321.25,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2.0
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '01/15/1989',
                gender: 'F',
                role: 'PRIMARY',
                monthlyPremium: 281.35,
                dailyPremium: 0,
                prepaidPremium: 0.0
              }
            ]
          }
        ],
        coreBenefits: {
          deductible: '1000',
          outOfPocketMax: '3000',
          userCoinsurance: '20',
          lifetimeMax: '100000',
          planType: 'Epic High Deductible PPO'
        }
      },
      '701': {
        planId: 701,
        productId: 30,
        brochureId: 1,
        carrierId: 5,
        jsonId: 1,
        planName: 'Pivot Health NEW CARRIER MULTI B',
        authorizeName: 'nric',
        addOnPlanIds: [],
        multiCarrierPlan: true,
        durations: [
          {
            policyDuration: 120,
            extendedDurationsAvailable: [120],
            durationId: 20,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 381.28,
              premium: 401.23,
              initialPayment: 421.18,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2.0
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '01/15/1989',
                gender: 'F',
                role: 'PRIMARY',
                monthlyPremium: 281.35,
                dailyPremium: 0,
                prepaidPremium: 0.0
              }
            ]
          },
          {
            policyDuration: 120,
            extendedDurationsAvailable: [120],
            durationId: 20,
            durationUnit: 'DAYS',
            sequence: 2,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 381.28,
              premium: 401.23,
              initialPayment: 421.18,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2.0
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '01/15/1989',
                gender: 'F',
                role: 'PRIMARY',
                monthlyPremium: 281.35,
                dailyPremium: 0,
                prepaidPremium: 0.0
              }
            ]
          },
          {
            policyDuration: 120,
            extendedDurationsAvailable: [120],
            durationId: 20,
            durationUnit: 'DAYS',
            sequence: 3,
            recurrence: 3,
            prepaid: null,
            monthly: {
              baseRate: 381.28,
              premium: 401.23,
              initialPayment: 421.18,
              taxes: [],
              fees: [
                {
                  name: 'Application Fee',
                  description: 'Application Fee',
                  value: 19.95
                },
                {
                  name: 'Billing Fee',
                  description: 'Billing Fee',
                  value: 17.95
                },
                {
                  name: 'Association Fee',
                  description: 'Association Fee',
                  value: 2.0
                }
              ],
              coverageDuration: 0
            },
            members: [
              {
                dob: '01/15/1989',
                gender: 'F',
                role: 'PRIMARY',
                monthlyPremium: 281.35,
                dailyPremium: 0,
                prepaidPremium: 0.0
              }
            ]
          }
        ],
        coreBenefits: {
          deductible: '2000',
          outOfPocketMax: '1000',
          userCoinsurance: '30',
          lifetimeMax: '250000',
          planType: 'Epic High Deductible PPO'
        }
      },
      '241': {
        planId: 241,
        productId: 12,
        brochureId: 1,
        carrierId: 4,
        jsonId: 1,
        planName: 'Latitude Select',
        authorizeName: 'latitude',
        addOnPlanIds: [],
        durations: [
          {
            policyDuration: 30,
            extendedDurationsAvailable: [],
            durationId: null,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2147483647,
            prepaid: null,
            monthly: {
              baseRate: 29.95,
              premium: 29.95,
              initialPayment: 29.95,
              taxes: [],
              fees: [],
              coverageDuration: 0
            },
            members: []
          }
        ],
        coreBenefits: {
          criticalIllness: '2500',
          accidentalDeath: '5000',
          hospitalBenefits: '250',
          accident: '2500'
        },
        legacyId: 'Latitude Select',
        oldPlanId: null
      },
      '242': {
        planId: 242,
        productId: 12,
        brochureId: 1,
        carrierId: 4,
        jsonId: 2,
        planName: 'Latitude Preferred',
        authorizeName: 'latitude',
        addOnPlanIds: [],
        durations: [
          {
            policyDuration: 30,
            extendedDurationsAvailable: [],
            durationId: null,
            durationUnit: 'DAYS',
            sequence: 1,
            recurrence: 2147483647,
            prepaid: null,
            monthly: {
              baseRate: 49.95,
              premium: 49.95,
              initialPayment: 49.95,
              taxes: [],
              fees: [],
              coverageDuration: 0
            },
            members: []
          }
        ],
        coreBenefits: {
          hospitalBenefits: '500',
          accidentalDeath: '5000',
          accident: '5000',
          criticalIllness: '5000'
        },
        legacyId: 'Latitude Preferred',
        oldPlanId: null
      }
    },
    multiCarrierOrder: {
      '1': [700, 600, 500],
      '2': [501, 601, 701]
    },
    plansByType: {
      '4': [10, 11, 345],
      '5': [14],
      '6': [
        448, 449, 450, 451, 452, 453, 454, 455, 456, 457, 458, 459, 460, 461, 462, 463,
        464, 465, 466, 467, 468, 469, 470, 471, 472, 473, 474, 475, 476, 477, 478, 479
      ],
      '11': [214, 215, 216, 217, 218, 246, 247, 243, 244, 245],
      '12': [241, 242],
      '13': [488, 489, 491, 492, 495, 494],
      '14': [403, 404, 406, 407, 409, 410],
      '15': [497, 498],
      '16': [
        363, 364, 365, 366, 368, 369, 370, 371, 373, 374, 375, 376, 378, 379, 380, 381,
        383, 384, 385, 386, 388, 389, 390, 391, 393, 394, 395, 396, 398, 399, 400, 401
      ],
      '17': [
        293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308,
        309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320
      ],
      '18': [325, 326]
    },
    jsons: {
      '1': 'https://cdn.qa.pivothealth.com/resources/v2/products/dental/details/dental-essential.json',
      '2': 'https://cdn.qa.pivothealth.com/resources/v2/products/dental/details/dental-maximum.json',
      '3': 'https://cdn.qa.pivothealth.com/resources/v2/products/dental/details/dental-value.json',
      '4': 'https://cdn.qa.pivothealth.com/resources/v2/products/vision/details/vision-low.json',
      '5': 'https://cdn.qa.pivothealth.com/resources/v2/products/quantum/details/quantum-copay-100.json',
      '6': 'https://cdn.qa.pivothealth.com/resources/v2/products/quantum/details/quantum-hd-100.json',
      '7': 'https://cdn.qa.pivothealth.com/resources/v2/products/quantum/details/quantum-copay-80.json',
      '8': 'https://cdn.qa.pivothealth.com/resources/',
      '9': 'https://cdn.qa.pivothealth.com/resources/v2/products/epic/details/FL-GA/NRIC-PPO.json',
      '10': 'https://cdn.qa.pivothealth.com/resources/v2/products/quantum/details/quantum-hd-70.json',
      '11': 'https://cdn.qa.pivothealth.com/resources/v2/products/epic/details/FL-GA/NRIC-PPO-with-RX.json',
      '12': 'https://cdn.qa.pivothealth.com/resources/v2/products/epic/details/FL-GA/NRIC-base.json',
      '13': 'https://cdn.qa.pivothealth.com/resources/v2/products/epic/details/FL-GA/NRIC-base-with-RX.json'
    },
    brochures: {
      '1': 'https://cdn.qa.pivothealth.com/resources/v2/products/dental/brochure/dental.pdf',
      '2': 'https://cdn.qa.pivothealth.com/resources/v2/products/quantum/brochure/PH_QuantumPPO-100623.pdf',
      '3': 'https://cdn.qa.pivothealth.com/resources/v2/products/choice/brochure/PHSTM-102822.pdf',
      '4': 'https://cdn.qa.pivothealth.com/resources/v2/products/choice/brochure/PHSTM-092122.pdf',
      '5': 'https://cdn.qa.pivothealth.com/resources/v2/products/economy/brochure/PHSTM-092122.pdf',
      '6': 'https://cdn.qa.pivothealth.com/resources/v2/products/epic/brochure/PH_EpicSTM092723-2.pdf',
      '7': 'https://cdn.qa.pivothealth.com/resources/v2/products/core/brochure/PH Core 091622.pdf',
      '8': 'https://cdn.qa.pivothealth.com/resources/pending brochure',
      '9': 'https://cdn.qa.pivothealth.com/resources/v2/products/deluxe/brochure/PHSTM-092122.pdf'
    },
    carriers: {
      '1': {
        name: 'Renaissance',
        logo: 'https://cdn.pivothealth.com/resources/v2/carriers/renaissance/images/logo.png',
        about: '<h1>disclaimer html</h1>'
      },
      '3': {
        name: 'Companion Life Insurance Company',
        logo: 'https://cdn.pivothealth.com/resources/v2/carriers/companion-life/images/logo.svg',
        about: '<h1>disclaimer</h1>'
      },
      '5': {
        name: 'North River Insurance Company',
        logo: 'https://cdn.pivothealth.com/resources/v2/carriers/north-river/images/NRIC-logo.svg',
        about: '<h1>disclaimer</h1>'
      }
    },
    childOnlyProductLines: [
      {
        productId: 17,
        productLine: 'EPIC',
        membersEligibleForChildOnly: false
      },
      {
        productId: 16,
        productLine: 'CHOICE',
        membersEligibleForChildOnly: false
      },
      {
        productId: 14,
        productLine: 'DELUXE',
        membersEligibleForChildOnly: false
      },
      {
        productId: 6,
        productLine: 'ECONOMY',
        membersEligibleForChildOnly: false
      },
      {
        productId: 11,
        productLine: 'QUANTUM',
        membersEligibleForChildOnly: false
      },
      {
        productId: 13,
        productLine: 'STANDARD',
        membersEligibleForChildOnly: false
      },
      {
        productId: 15,
        productLine: 'CORE',
        membersEligibleForChildOnly: false
      }
    ]
  }
}
